import React from 'react'
import { useState } from 'react';
import AdminNavbar from "../Navbars/AdminNavbar";
import Sidebar from "../Sidebar/Sidebar";
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { AuthApis } from '../../apis/authApis';
import AdminSidebar from '../Sidebar/AdminSidebar';
import { STATUSTYPES } from '../Reusable/Status';
import { convertUTCDateToLocalDate, getDeadlineStatus } from '../Reusable/functions';
import { Oval } from 'react-loader-spinner';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { MdDownload } from "react-icons/md";
import * as XLSX from 'xlsx';

// Keep your existing interfaces
interface Shipment {
  connoteForm: string;
  shipper: string;
  receiver: string;
  goodsDesc: string;
  weight: string;
}

interface ShipmentData {
  created_at: string;
  fleet_name: string;
  manifest_id: string;
  destination_state: string;
  manifest_name: string;
  // Despite the name this holds the airway bill TEXT, not a foreign key — the create
  // form posts selectedAirwaybillNumber.airwaybill_number straight into it, and the
  // manifest list prints it as-is. Optional because manifests raised before airway
  // bills were recorded have none.
  airwaybill_number_id?: string | null;
  shipments: any[];
}

interface Shipments {
  SenderName: string;
  SenderAddCity: string;
  ReceiverName: string;
  ReceiverAddCity: string;
  GoodsDescription: string;
  Status: string;
  Weight: string;
  NoOfItems: number;
  ReceiverAdd1: string;
}

interface Manifests {
  id: number;
  manifest_name: string;
  manifest_id: string;
  sender_state: string;
  destination_state: string;
  created_at: string;
  created_by: number;
  creator?: {
    id: number;
    name: string;
    email: string;
  };
  shipments: Shipments[];
  fleet_name: string;
  shipment_status: string;
  goods_description: string;
  pcs: string;
  weight: string;
  custom_value: string;
}


const getCurrentDateTimeLocal = (): string => {
  const now = new Date();
  // Adjust for timezone offset to get local time
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, 16);
};


const formatDateTimeDisplay = (datetime: string | Date | null): string => {
  if (!datetime) return 'N/A';
  const date = new Date(datetime);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

// Enhanced Filter Component
const ManifestFilters: React.FC<any> = ({
  filters,
  onFiltersChange,
  onClearFilters,
  onApplyFilters,
}) => {
  const [localFilters, setLocalFilters] = React.useState<any>(filters);
  const userLoginData = useSelector((state: any) => state.data.login.value);

  const [allBranches, setAllBranches] = React.useState<any>([]);

  React.useEffect(() => {
    SuperAdminApis.getAllBranchesSimple().then(
      (response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setAllBranches(response?.data?.data);
        }
      }
    ).catch(function (error) {
      console.error('Error loading branches:', error);
    })
  }, []);

  React.useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleFilterChange = (field: keyof any, value: string) => {
    const updatedFilters = { ...localFilters, [field]: value };
    setLocalFilters(updatedFilters);
  };

  const applyFilters = () => {
    onFiltersChange(localFilters);
    onApplyFilters(localFilters);
  };

  const clearFilters = () => {
    const emptyFilters: any = {
      start_date: '',
      end_date: '',
      sender_branch: '',          // Changed from sender_state
      destination_branch: '',     // Changed from destination_state
      created_by: '',
      type: 'all',
      audit_only: '',
      search: ''
    };
    setLocalFilters(emptyFilters);
    onFiltersChange(emptyFilters);
    onClearFilters(emptyFilters);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border mb-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Filter Manifests</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
          <input
            type="text"
            value={localFilters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
            placeholder="Search manifests..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          />
        </div>

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input
            type="date"
            value={localFilters.start_date}
            onChange={(e) => handleFilterChange('start_date', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          />
        </div>

        {/* End Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input
            type="date"
            value={localFilters.end_date}
            onChange={(e) => handleFilterChange('end_date', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          />
        </div>

        {/* Filter Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Filter Type</label>
          <select
            value={localFilters.type}
            onChange={(e) => handleFilterChange('type', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          >
            <option value="all">All Manifests</option>
            <option value="outbound">Outbound</option>
            <option value="inbound">Inbound</option>
          </select>
        </div>

        {/* Audit-only manifests */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Audit Manifests</label>
          <select
            value={localFilters.audit_only || ''}
            onChange={(e) => handleFilterChange('audit_only', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          >
            <option value="">Include audit manifests</option>
            <option value="only">Audit manifests only</option>
            <option value="exclude">Exclude audit manifests</option>
          </select>
        </div>

        {/* Origin Branch Filter - UPDATED */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Origin Branch</label>
          <select
            value={localFilters.sender_branch}
            onChange={(e) => handleFilterChange('sender_branch', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
          >
            <option value="">All Origin Branches</option>
            {allBranches.map((branch: any) => (
              <option key={branch.id} value={branch.branch_name}>{branch.branch_name} ({branch.state})</option>
            ))}
          </select>
        </div>

        {/* Destination Branch Filter - UPDATED */}
        {userLoginData?.data?.role === 'admin' &&
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Destination Branch</label>
            <select
              value={localFilters.destination_branch}
              onChange={(e) => handleFilterChange('destination_branch', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#E04343]"
            >
              <option value="">All Destination Branches</option>
              {allBranches.map((branch: any) => (
                <option key={branch.id} value={branch.branch_name}>{branch.branch_name} ({branch.state})</option>
              ))}
            </select>
          </div>}

        {/* Action Buttons */}
        <div className="md:col-span-2 lg:col-span-2 flex items-end gap-2">
          <button
            onClick={applyFilters}
            className="bg-[#E04343] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-red-600 transition-colors"
          >
            Apply Filters
          </button>
          <button
            onClick={clearFilters}
            className="bg-gray-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-600 transition-colors"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
};

// Statistics Cards Component
const StatisticsCards: React.FC<any> = ({ manifestData, filters }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <div className="text-2xl font-bold text-blue-600">{manifestData?.total || 0}</div>
        <div className="text-sm text-gray-600">Total Manifests</div>
        <div className="text-xs text-gray-500 mt-1">Current search results</div>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <div className="text-2xl font-bold text-green-600">
          {filters.type === 'all' ? 'All' : filters.type === 'outbound' ? 'Outbound' : 'Inbound'}
        </div>
        <div className="text-sm text-gray-600">Filter Type</div>
        <div className="text-xs text-gray-500 mt-1">Currently viewing</div>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <div className="text-2xl font-bold text-purple-600">{manifestData?.current_page || 1}</div>
        <div className="text-sm text-gray-600">Current Page</div>
        <div className="text-xs text-gray-500 mt-1">of {manifestData?.last_page || 1} total</div>
      </div>
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <div className="text-2xl font-bold text-orange-600">{manifestData?.per_page || 15}</div>
        <div className="text-sm text-gray-600">Per Page</div>
        <div className="text-xs text-gray-500 mt-1">Records shown</div>
      </div>
    </div>
  );
};

// Enhanced Export Function
const exportToExcel = (data: Manifests[]) => {
  const exportData = data?.flatMap((manifest: any) => {
    // if (!manifest.shipments || manifest.shipments.length === 0) {
    return [{
      'Manifest Name': manifest.manifest_name,
      'Manifest ID': manifest.manifest_id,
      'Air Way Bill Number': manifest.airwaybill_number_id,
      'Sender Branch': manifest.sender_state,
      'Destination Branch': manifest.destination_state,
      'Created At': convertUTCDateToLocalDate(manifest.created_at),
      'Created By': manifest.created_by || 'N/A',
      // 'Creator Email': manifest.creator?.email || 'N/A',
      'Fleet Name': manifest.fleet_name,
      'Status': manifest.shipment_status,
      'Total Shipments': manifest.shipments.length,
      'Total Weight': manifest.weight,
      'Total Pieces': manifest.pcs,
      'Custom Value': manifest.custom_value
    }];
    // }

    // return manifest.shipments?.map((shipment: any, index: any) => ({
    //   'Manifest Name': manifest.manifest_name,
    //   'Manifest ID': manifest.manifest_id,
    //   'Sender Branch': manifest.sender_state,
    //   'Destination Branch': manifest.destination_state,
    //   'Created At': convertUTCDateToLocalDate(manifest.created_at),
    //   'Created By': manifest.created_by || 'N/A',
    //   // 'Creator Email': manifest.creator?.email || 'N/A',
    //   'Fleet Name': manifest.fleet_name,
    //   'Manifest Status': manifest.shipment_status,
    //   'Shipment Sender Name': shipment.SenderName,
    //   'Shipment Sender City': shipment.SenderAddCity,
    //   'Shipment Receiver Name': shipment.ReceiverName,
    //   'Shipment Receiver City': shipment.ReceiverAddCity,
    //   'Goods Description': shipment.GoodsDescription,
    //   'Shipment Status': shipment.Status,
    //   'Total Shipments': manifest.shipments.length,
    //   'Weight': shipment.Weight,
    //   'Number of Items': shipment.NoOfItems,
    //   'Receiver Address': shipment.ReceiverAdd1,
    // }));
  });

  const workbook = XLSX?.utils?.book_new();
  const worksheet = XLSX.utils?.json_to_sheet(exportData);
  XLSX?.utils?.book_append_sheet(workbook, worksheet, 'Manifests');
  XLSX?.writeFile(workbook, `manifests_${new Date().toISOString().split('T')[0]}.xlsx`);
};

const exportShipmentsToExcel = (manifestInfo: any, shipmentsData: any[]) => {
  if (!shipmentsData || shipmentsData.length === 0) {
    toast.error('No shipments to export');
    return;
  }

  const exportData = shipmentsData.map((shipment: any, index: number) => ({
    'S/N': index + 1,
    'Manifest Name': manifestInfo?.manifest_name || 'N/A',
    'Manifest ID': manifestInfo?.manifest_id || 'N/A',
    'Air Way Bill Number': manifestInfo.airwaybill_number_id,
    'Receiver Name': shipment?.ReceiverName || shipment?.receiver_name || 'N/A',
    'Receiver Phone': shipment?.ReceiverPhone || shipment?.receiver_phone || 'N/A',
    'Receiver Address': shipment?.ReceiverAdd1 || shipment?.receiver_address || 'N/A',
    'Receiver City': shipment?.ReceiverAddCity || 'N/A',
    'Receiver State': shipment?.ReceiverAddState || 'N/A',
    'Status': shipment?.Status || shipment?.status || 'Unknown',
    'Shipment Number': shipment?.ShipmentNumber || shipment?.shipment_number || 'Not Available',
    'Weight (kg)': shipment?.Weight || shipment?.weight || '0',
    'Custom Value': shipment?.CustomValue ?? shipment?.custom_value ?? '0',
    'Custom Currency': shipment?.CustomCurrencyCode || shipment?.custom_currency || 'N/A',
    'Number of Items': shipment?.NoOfItems || shipment?.number_of_items || '0',
    'Sender Name': shipment?.SenderName || 'N/A',
    'Sender Phone': shipment?.SenderPhone || 'N/A',
    'Sender Address': shipment?.SenderAdd1 || 'N/A',
    'Goods Description': shipment?.GoodsDescription || 'N/A',
    'Fleet Name': manifestInfo?.fleet_name || 'N/A',
    // ── NEW ──────────────────────────────────────────────────
    '1st OFD Date & Time': shipment?.ofd_created_at || 'N/A',
    'Shipment Status Date & Time': shipment?.event_datetime || 'N/A',
    'Delivery Attempts': shipment?.delivery_attempts ?? 0,
    // Net amount credited to the wallet after any late fine, and the email of
    // the wallet that received it (the fleet's, for riders under a fleet).
    // Blank until the shipment reaches POD, so the column stays summable.
    // Delivery payment detail. Blank until the shipment reaches POD and a payment
    // exists — kept blank rather than "N/A" so the money columns stay numeric and
    // Excel can SUM them. "Delivered By" and "Paid To" differ for every fleet rider:
    // the rider makes the delivery, the fleet owns the wallet that gets credited.
    'Delivered By (Rider)': shipment?.rider_name || '',
    'Rider Email': shipment?.rider_email || '',
    'Paid To (Wallet Owner)': shipment?.wallet_name || '',
    'Wallet Email': shipment?.wallet_email || '',
    'Delivery Rate': shipment?.gross_amount != null ? Number(shipment.gross_amount) : '',
    'Fine Amount': shipment?.fine_amount != null ? Number(shipment.fine_amount) : '',
    'Fine Days': shipment?.fine_days != null ? Number(shipment.fine_days) : '',
    'Amount Paid (Net)': shipment?.delivery_cost != null ? Number(shipment.delivery_cost) : '',
    // ─────────────────────────────────────────────────────────
    'Export Date': new Date().toLocaleString(),
  }));

  const workbook = XLSX?.utils?.book_new();
  const worksheet = XLSX.utils?.json_to_sheet(exportData);

  // Auto-adjust column widths
  const colWidths = [
    { wch: 5 },   // S/N
    { wch: 20 },  // Manifest Name
    { wch: 15 },  // Manifest ID
    { wch: 20 },  // Air Way Bill Number
    { wch: 20 },  // Receiver Name
    { wch: 15 },  // Receiver Phone
    { wch: 30 },  // Receiver Address
    { wch: 15 },  // Receiver City
    { wch: 15 },  // Receiver State
    { wch: 15 },  // Status
    { wch: 15 },  // Shipment Number
    { wch: 10 },  // Weight
    { wch: 14 },  // Custom Value
    { wch: 12 },  // Custom Currency
    { wch: 10 },  // Items
    { wch: 20 },  // Sender Name
    { wch: 15 },  // Sender Phone
    { wch: 30 },  // Sender Address
    { wch: 25 },  // Goods Description
    { wch: 15 },  // Fleet Name
    { wch: 22 },  // 1st OFD Date & Time
    { wch: 22 },  // Shipment Status Date & Time
    { wch: 12 },  // Delivery Attempts
    { wch: 22 },  // Delivered By (Rider)
    { wch: 30 },  // Rider Email
    { wch: 24 },  // Paid To (Wallet Owner)
    { wch: 30 },  // Wallet Email
    { wch: 14 },  // Delivery Rate
    { wch: 12 },  // Fine Amount
    { wch: 10 },  // Fine Days
    { wch: 18 },  // Amount Paid (Net)
    { wch: 20 },  // Export Date
  ];
  worksheet['!cols'] = colWidths;

  XLSX?.utils?.book_append_sheet(workbook, worksheet, 'Shipments');

  const fileName = `shipments_${manifestInfo?.manifest_id || 'manifest'}_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX?.writeFile(workbook, fileName);

  toast.success(`Exported ${exportData.length} shipments successfully!`);
};




// Keep your existing PDF styles and component
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
  },
  section: {
    marginBottom: 10,
  },
  header: {
    fontSize: 14,
    marginBottom: 10,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  table: {
    display: 'flex',
    paddingTop: 40,
    flexDirection: 'column',
    width: '100%',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #000',
    paddingBottom: 4,
    marginBottom: 4,
  },
  tableCol: {
    flex: 1,
    padding: 4,
  },
  tableColl: {
    flex: 3,
    fontSize: 10,
    padding: 4,
    fontWeight: 'bold',
  },
  tableColHeader: {
    flex: 1,
    padding: 4,
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold',
  },
  footer: {
    marginTop: 20,
    paddingTop: '50px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footer2: {
    marginTop: 20,
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 10
  },
  logo: {
    width: 100,
    height: 'auto',
    marginBottom: 20,
  }
});

function convertStringToTwoDecimals(value: string): number {
  const parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return 0;
  }
  return parseFloat(parsed.toFixed(2));
}

let totalWgt = 0;

const ShipmentManifest = ({ data }: { data: ShipmentData }) => (
  <Document>
    {totalWgt = 0}
    {data.shipments.map((shipment, index) => (
      totalWgt += convertStringToTwoDecimals(shipment.Weight)
    ))
    }
    <Page style={styles.page}>
      <View>
        <Image
          style={styles.logo}
          src="/images/Auth/logo.png"
        />
      </View>
      <Text style={styles.header}>Manifest</Text>

      <View style={styles.section}>
        <Text style={{ paddingBottom: 8 }}><Text style={{ fontWeight: 'bold' }}>Date</Text> : {convertUTCDateToLocalDate(data.created_at)}</Text>
        <Text style={{ paddingBottom: 8 }}><Text style={{ fontWeight: 'bold' }}>Fleet</Text> : {data.fleet_name}</Text>
        <Text style={{ paddingBottom: 8 }}> <Text style={{ fontWeight: 'bold' }}>Manifest Name</Text> : {data.manifest_name}</Text>
        {/* Printed only when the manifest has one. An "AirwayBill No. : --" line on
            every older manifest would be noise on a document people sign. */}
        {data.airwaybill_number_id ? (
          <Text style={{ paddingBottom: 8 }}> <Text style={{ fontWeight: 'bold' }}>AirwayBill No.</Text> : {data.airwaybill_number_id}</Text>
        ) : null}
        <Text style={{ paddingBottom: 8 }}> <Text style={{ fontWeight: 'bold' }}>Manifest Id</Text> : {data.manifest_id} /  <Text style={{ fontWeight: 'bold' }}>Total Weight</Text> : {totalWgt} KG</Text>
        <Text> <Text style={{ fontWeight: 'bold' }}>Destination</Text> : {data.destination_state}</Text>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableCol}>
            <Text>Shipment Id #</Text>
          </View >
          <View style={styles.tableCol}>
            <Text>Shipper</Text>
          </View>
          <View style={styles.tableColl}>
            <Text>Receiver</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Weight</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Pcs</Text>
          </View>
          <View style={styles.tableCol}>
            <Text>Notes</Text>
          </View>
        </View>
        {data.shipments.map((shipment, index) => (
          <View key={index} style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text>{shipment.ShipmentNumber}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{shipment.SenderName},{shipment.SenderAddState},{shipment.SenderCountryCode} </Text>
            </View>
            <View style={styles.tableColl}>
              <Text>{shipment.ReceiverName},{shipment.ReceiverAdd1},{shipment.ReceiverAddState},{shipment.ReceiverCountryCode},{shipment.ReceiverPhone}  </Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{shipment.Weight} {shipment.WeightMeasurement} </Text>
            </View>
            <View style={styles.tableCol}>
              <Text>{shipment.NoOfItems} </Text>
            </View>
            <View style={styles.tableCol}>
            </View>
          </View>
        ))}
      </View>

      <View style={styles.footer2}>
        <Text style={styles.footerText}>Total Shipments: {data.shipments.length} </Text><br />
        <Text style={styles.footerText}>Total Weights: {totalWgt}</Text><br />
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>Driver's Signature: ______________________</Text>
        <Text style={styles.footerText}>Collected date/time: ______________________</Text>
      </View>
    </Page>
  </Document >
);

function Manifest() {
  const navigate = useNavigate();
  const userLoginData = useSelector((state: any) => state.data.login.value);

  // State Management
  const [userLists, setUserList] = React.useState<any>([]);
  const [stateFrom, setStateFrom] = React.useState<any>([]);
  const [searchText, setSearchText] = React.useState('');
  const [riders, setRiders] = React.useState<any>([]);
  const [vehicle, setVehicle] = React.useState<any>([]);
  const [shipmentInfo, setShipmentInfo] = React.useState<any>([]);
  const [manifestListData, setmanifestListData] = React.useState<any>([]);
  const [runmanifestListData, setrunmanifestListData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [screenLoader, setScreenLoader] = React.useState<boolean>(false);
  const [loadingDocId, setLoadingDocId] = React.useState<string | null>(null);
  const [addModal, setAddModal] = React.useState<boolean>(false);
  const [riderModal, setRiderModal] = React.useState<boolean>(false);
  const [tabNo, setTabNo] = React.useState<any>('1');
  const [fleetData, setFleetData] = React.useState<any>([]);
  const [fleetData2, setFleetData2] = React.useState<any>([]);
  const [percentage, setPercentage] = React.useState<any>(0);
  const [showShipment, setShowShipment] = React.useState<boolean>(false);
  const [manifestData, setManifestData] = React.useState<any>([]);
  const [rejectedNo, setRejectedNo] = React.useState<any>('');
  const [barcodeValues, setBarcodeValues] = React.useState<string[]>([]);
  const [currentInput, setCurrentInput] = React.useState<string>("");
  const [shipmentRider, setShipmentRider] = React.useState<any>('');
  const [deadLine, setDeadLine] = React.useState<string>('');
  const [shipmentStatusId, setShipmentStatusId] = React.useState<any>('');
  const [shipType, setShipType] = React.useState<any>('in_bound');
  const [validationTimeout, setValidationTimeout] = useState<NodeJS.Timeout | null>(null);
  const [validationResults, setValidationResults] = useState<{ [key: string]: 'valid' | 'invalid' | 'duplicate' }>({});
  const [isValidating, setIsValidating] = useState(false);

  // Manifest type (fleet or individual)
  const [manifestType, setManifestType] = useState<string>('fleet');

  // Audit-only manifest: records a corrected shipment grouping without touching
  // shipment state. For shipments that landed on the wrong manifest and have
  // already been POD'd — a normal manifest would be refused outright
  // (ALL_SHIPMENTS_BLOCKED) or would drag a delivered shipment backwards.
  const [isAuditOnly, setIsAuditOnly] = useState<boolean>(false);

  // Geofencing — track receiver states per shipment
  const [shipmentStates, setShipmentStates] = useState<{ [key: string]: string }>({});
  const [geofenceMismatches, setGeofenceMismatches] = useState<string[]>([]);
  const [nextPageId, setNextPageId] = React.useState<any>([]);
  const [isUpdatingBatch, setIsUpdatingBatch] = React.useState<boolean>(false);
  const [updateProgress, setUpdateProgress] = React.useState<number>(0);
  const [updateBatchInfo, setUpdateBatchInfo] = React.useState<{
    currentBatch: number;
    totalBatches: number;
    updatedCount: number;
    failedCount: number;
    totalShipments: number;
    apiCallsMade?: number;  // NEW
    apiSuccessCount?: number;  // NEW
    apiFailedCount?: number;  // NEW
  }>({
    currentBatch: 0,
    totalBatches: 0,
    updatedCount: 0,
    failedCount: 0,
    totalShipments: 0,
    apiCallsMade: 0,
    apiSuccessCount: 0,
    apiFailedCount: 0
  });


  const [eventDateTime, setEventDateTime] = React.useState<string>(getCurrentDateTimeLocal());
  const [statusUpdateDateTime, setStatusUpdateDateTime] = React.useState<string>(getCurrentDateTimeLocal());

  const [shipmentSearchText, setShipmentSearchText] = React.useState<string>('');
  const [activeStatusFilter, setActiveStatusFilter] = React.useState<string | null>(null);

  const filteredShipments = React.useMemo(() => {
    if (!manifestData?.shipments) return [];

    let filtered = [...manifestData.shipments];

    // Filter by active status filter
    if (activeStatusFilter) {
      filtered = filtered.filter((shipment: any) => {
        const status = shipment?.Status || shipment?.status || 'Unknown';
        return status.toLowerCase() === activeStatusFilter.toLowerCase();
      });
    }

    // Filter by search text
    if (shipmentSearchText.trim()) {
      const searchLower = shipmentSearchText.toLowerCase().trim();
      filtered = filtered.filter((shipment: any) => {
        const receiverName = (shipment?.ReceiverName || shipment?.receiver_name || '').toLowerCase();
        const receiverPhone = (shipment?.ReceiverPhone || shipment?.receiver_phone || '').toLowerCase();
        const receiverAddress = (shipment?.ReceiverAdd1 || shipment?.receiver_address || '').toLowerCase();
        const shipmentNumber = (shipment?.ShipmentNumber || shipment?.shipment_number || '').toLowerCase();
        const status = (shipment?.Status || shipment?.status || '').toLowerCase();
        const senderName = (shipment?.SenderName || '').toLowerCase();

        return (
          receiverName.includes(searchLower) ||
          receiverPhone.includes(searchLower) ||
          receiverAddress.includes(searchLower) ||
          shipmentNumber.includes(searchLower) ||
          status.includes(searchLower) ||
          senderName.includes(searchLower)
        );
      });
    }

    return filtered;
  }, [manifestData?.shipments, shipmentSearchText, activeStatusFilter]);



  // Add these state variables after your existing state declarations
  const [airwaybillNumbers, setAirwaybillNumbers] = React.useState<any>([]);
  const [selectedAirwaybillNumber, setSelectedAirwaybillNumber] = React.useState<any>(null);
  const [showAirwaybillCreateModal, setShowAirwaybillCreateModal] = React.useState(false);
  const [showAirwaybillDrawer, setShowAirwaybillDrawer] = React.useState(false);
  const [airwaybillLoading, setAirwaybillLoading] = React.useState(false);
  const [airwaybillSearchTerm, setAirwaybillSearchTerm] = React.useState('');
  const [editingAirwaybill, setEditingAirwaybill] = React.useState<any>(null);



  const [isExportingAll, setIsExportingAll] = React.useState<boolean>(false);




  /**
 * Export ALL filtered manifests (regardless of pagination)
 */
  const exportAllFilteredManifests = async () => {
    // Check if there are any results to export
    if (!userLists?.total || userLists.total === 0) {
      toast.warning('No manifests to export. Please adjust your filters.');
      return;
    }

    setIsExportingAll(true);

    try {
      // Send current filter parameters to get all matching records with shipments
      const response: any = await SuperAdminApis.exportAllFilteredManifests({
        search: filters.search,
        start_date: filters.start_date,
        end_date: filters.end_date,
        sender_state: filters.sender_state,
        destination_state: filters.destination_state,
        sender_branch: filters.sender_branch,
        destination_branch: filters.destination_branch,
        type: filters.type,
        created_by: filters.created_by,
      });

      if (response?.data?.status && response?.data?.data?.shipments) {
        const shipmentsData = response.data.data.shipments;

        if (shipmentsData.length === 0) {
          toast.warning('No shipments found in the filtered manifests');
          return;
        }

        // Transform data for Excel export - SAME FORMAT AS exportMultipleManifests
        const exportData = shipmentsData.map((item: any, index: number) => ({
          'S/N': index + 1,
          'Manifest Name': item.manifest_info.manifest_name,
          'Manifest ID': item.manifest_info.manifest_id,
          'Air Way Bill Number': item.manifest_info.airwaybill_number_id,
          'Origin Branch': item.manifest_info.origin_branch,
          'Destination Branch': item.manifest_info.destination_branch,
          'Fleet Name': item.manifest_info.fleet_name,
          'Manifest Status': item.manifest_info.manifest_status,
          'Manifest Created': new Date(item.manifest_info.created_at).toLocaleString(),
          'Created By': item.manifest_info.created_by || 'N/A',
          'Shipment Number': item.shipment_info.shipment_number,
          'Receiver Name': item.shipment_info.receiver_name,
          'Receiver Phone': item.shipment_info.receiver_phone,
          'Receiver Address': item.shipment_info.receiver_address,
          'Receiver City': item.shipment_info.receiver_city,
          'Receiver State': item.shipment_info.receiver_state,
          'Shipment Status': item.shipment_info.shipment_status,
          'Weight (kg)': item.shipment_info.weight,
          'Custom Value': item.shipment_info.custom_value ?? '0',
          'Custom Currency': item.shipment_info.custom_currency || 'N/A',
          'Delivery Notes': item.shipment_info.notes,
          'Number of Items': item.shipment_info.number_of_items,
          'Sender Name': item.shipment_info.sender_name,
          'Sender Phone': item.shipment_info.sender_phone,
          'Sender Address': item.shipment_info.sender_address,
          'Goods Description': item.shipment_info.goods_description,
          // ── NEW ──────────────────────────────────────────────────
          '1st OFD Date & Time': item.shipment_info.ofd_1st_datetime || 'N/A',
          'Shipment Status Date & Time': item.shipment_info.status_datetime || 'N/A',
          'Delivery Attempts': item.shipment_info.delivery_attempts ?? 0,
          // Net amount credited to the wallet after any late fine, and the email
          // of the wallet that received it (the fleet's, for riders under a
          // fleet). Blank until POD, so the column stays summable in Excel.
          // See exportShipmentsToExcel for why these are blank rather than 'N/A',
          // and why "Delivered By" and "Paid To" are separate columns.
          'Delivered By (Rider)': item.shipment_info.rider_name || '',
          'Rider Email': item.shipment_info.rider_email || '',
          'Paid To (Wallet Owner)': item.shipment_info.wallet_name || '',
          'Wallet Email': item.shipment_info.wallet_email || '',
          'Delivery Rate': item.shipment_info.gross_amount != null ? Number(item.shipment_info.gross_amount) : '',
          'Fine Amount': item.shipment_info.fine_amount != null ? Number(item.shipment_info.fine_amount) : '',
          'Fine Days': item.shipment_info.fine_days != null ? Number(item.shipment_info.fine_days) : '',
          'Amount Paid (Net)': item.shipment_info.delivery_cost != null ? Number(item.shipment_info.delivery_cost) : '',
          // ─────────────────────────────────────────────────────────
          'Export Date': new Date().toLocaleString(),
        }));

        // Create Excel file
        const workbook = XLSX?.utils?.book_new();
        const worksheet = XLSX.utils?.json_to_sheet(exportData);

        // Auto-adjust column widths - same as exportMultipleManifests
        const colWidths = [
          { wch: 5 },   // S/N
          { wch: 20 },  // Manifest Name
          { wch: 15 },  // Manifest ID
          { wch: 20 },  // Air Way Bill Number
          { wch: 20 },  // Origin Branch
          { wch: 20 },  // Destination Branch
          { wch: 15 },  // Fleet Name
          { wch: 15 },  // Manifest Status
          { wch: 20 },  // Manifest Created
          { wch: 15 },  // Created By
          { wch: 15 },  // Shipment Number
          { wch: 20 },  // Receiver Name
          { wch: 15 },  // Receiver Phone
          { wch: 35 },  // Receiver Address
          { wch: 15 },  // Receiver City
          { wch: 15 },  // Receiver State
          { wch: 15 },  // Shipment Status
          { wch: 10 },  // Weight
          { wch: 14 },  // Custom Value
          { wch: 12 },  // Custom Currency
          { wch: 20 },  // Delivery Notes
          { wch: 10 },  // Items
          { wch: 20 },  // Sender Name
          { wch: 15 },  // Sender Phone
          { wch: 35 },  // Sender Address
          { wch: 30 },  // Goods Description
          { wch: 22 },  // 1st OFD Date & Time
          { wch: 22 },  // Shipment Status Date & Time
          { wch: 12 },  // Delivery Attempts
          { wch: 22 },  // Delivered By (Rider)
          { wch: 30 },  // Rider Email
          { wch: 24 },  // Paid To (Wallet Owner)
          { wch: 30 },  // Wallet Email
          { wch: 14 },  // Delivery Rate
          { wch: 12 },  // Fine Amount
          { wch: 10 },  // Fine Days
          { wch: 18 },  // Amount Paid (Net)
          { wch: 20 },  // Export Date
        ];
        worksheet['!cols'] = colWidths;

        XLSX?.utils?.book_append_sheet(workbook, worksheet, 'All Filtered Shipments');

        // Generate filename with info
        const filterInfo = filters.type !== 'all' ? `_${filters.type}` : '';
        const fileName = `all_filtered_manifests${filterInfo}_${response.data.data.manifests_count}_manifests_${response.data.data.total_shipments}_shipments_${new Date().toISOString().split('T')[0]}.xlsx`;

        XLSX?.writeFile(workbook, fileName);

        toast.success(`Successfully exported ${response.data.data.total_shipments} shipments from ${response.data.data.manifests_count} manifests!`);

      } else {
        console.log(response?.message);
        toast.error(response?.data?.message || 'No data received from server');
      }
    } catch (error: any) {
      console.error('Export all filtered error:', error);

      // Handle specific error for too many records
      if (error?.response?.status === 400 && error?.response?.data?.max_allowed) {
        toast.error(`Export limit exceeded. Maximum ${error.response.data.max_allowed} manifests allowed. Found ${error.response.data.total_filtered}. Please refine your filters.`);
      } else {
        console.log(error?.response?.message);
        toast.error(error?.response?.data?.message || 'Failed to export manifests');
      }
    } finally {
      setIsExportingAll(false);
    }
  };

  // New airwaybill form data
  const [airwaybillFormData, setAirwaybillFormData] = React.useState({
    airwaybill_number: '',
    description: '',
    status: 'active'
  });

  const [selectedManifests, setSelectedManifests] = React.useState<number[]>([]);
  const [isExportingMultiple, setIsExportingMultiple] = React.useState(false);

  // Add this function to handle checkbox selection
  const handleManifestSelection = (manifestId: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedManifests(prev => [...prev, manifestId]);
    } else {
      setSelectedManifests(prev => prev.filter(id => id !== manifestId));
    }
  };

  // Add this function to handle "select all"
  const handleSelectAll = (isChecked: boolean) => {
    if (isChecked) {
      const allIds = userLists?.data?.map((manifest: any) => manifest.id) || [];
      setSelectedManifests(allIds);
    } else {
      setSelectedManifests([]);
    }
  };



  // Add this function to export multiple manifests
  const exportMultipleManifests = async () => {
    if (selectedManifests.length === 0) {
      toast.warning('Please select at least one manifest to export');
      return;
    }

    setIsExportingMultiple(true);

    try {
      const response = await SuperAdminApis.exportMultipleManifests(selectedManifests);

      if (response?.data?.status && response?.data?.data?.shipments) {
        const shipmentsData = response.data.data.shipments;

        // Transform data for Excel export
        const exportData = shipmentsData.map((item: any, index: number) => ({
          'S/N': index + 1,
          'Manifest Name': item.manifest_info.manifest_name,
          'Manifest ID': item.manifest_info.manifest_id,
          'Air Way Bill Number': item.manifest_info.airwaybill_number_id,
          'Origin Branch': item.manifest_info.origin_branch,
          'Destination Branch': item.manifest_info.destination_branch,
          'Fleet Name': item.manifest_info.fleet_name,
          'Manifest Status': item.manifest_info.manifest_status,
          'Manifest Created': new Date(item.manifest_info.created_at).toLocaleString(),
          'Created By': item.manifest_info.created_by || 'N/A',
          'Shipment Number': item.shipment_info.shipment_number,
          'Receiver Name': item.shipment_info.receiver_name,
          'Receiver Phone': item.shipment_info.receiver_phone,
          'Receiver Address': item.shipment_info.receiver_address,
          'Receiver City': item.shipment_info.receiver_city,
          'Receiver State': item.shipment_info.receiver_state,
          'Shipment Status': item.shipment_info.shipment_status,
          'Weight (kg)': item.shipment_info.weight,
          'Custom Value': item.shipment_info.custom_value ?? '0',
          'Custom Currency': item.shipment_info.custom_currency || 'N/A',
          'Number of Items': item.shipment_info.number_of_items,
          'Sender Name': item.shipment_info.sender_name,
          'Sender Phone': item.shipment_info.sender_phone,
          'Sender Address': item.shipment_info.sender_address,
          'Goods Description': item.shipment_info.goods_description,
          // ── NEW ──────────────────────────────────────────────────
          '1st OFD Date & Time': item.shipment_info.ofd_1st_datetime || 'N/A',
          'Shipment Status Date & Time': item.shipment_info.status_datetime || 'N/A',
          'Delivery Attempts': item.shipment_info.delivery_attempts ?? 0,
          // Net amount credited to the wallet after any late fine, and the email
          // of the wallet that received it (the fleet's, for riders under a
          // fleet). Blank until POD, so the column stays summable in Excel.
          // See exportShipmentsToExcel for why these are blank rather than 'N/A',
          // and why "Delivered By" and "Paid To" are separate columns.
          'Delivered By (Rider)': item.shipment_info.rider_name || '',
          'Rider Email': item.shipment_info.rider_email || '',
          'Paid To (Wallet Owner)': item.shipment_info.wallet_name || '',
          'Wallet Email': item.shipment_info.wallet_email || '',
          'Delivery Rate': item.shipment_info.gross_amount != null ? Number(item.shipment_info.gross_amount) : '',
          'Fine Amount': item.shipment_info.fine_amount != null ? Number(item.shipment_info.fine_amount) : '',
          'Fine Days': item.shipment_info.fine_days != null ? Number(item.shipment_info.fine_days) : '',
          'Amount Paid (Net)': item.shipment_info.delivery_cost != null ? Number(item.shipment_info.delivery_cost) : '',
          // ─────────────────────────────────────────────────────────
          'Export Date': new Date().toLocaleString(),
        }));

        // Create Excel file
        const workbook = XLSX?.utils?.book_new();
        const worksheet = XLSX.utils?.json_to_sheet(exportData);

        // Auto-adjust column widths
        const colWidths = [
          { wch: 5 },   // S/N
          { wch: 20 },  // Manifest Name
          { wch: 15 },  // Manifest ID
          { wch: 20 },  // Air Way Bill Number
          { wch: 20 },  // Origin Branch
          { wch: 20 },  // Destination Branch
          { wch: 15 },  // Fleet Name
          { wch: 15 },  // Manifest Status
          { wch: 20 },  // Manifest Created
          { wch: 15 },  // Created By
          { wch: 15 },  // Shipment Number
          { wch: 20 },  // Receiver Name
          { wch: 15 },  // Receiver Phone
          { wch: 35 },  // Receiver Address
          { wch: 15 },  // Receiver City
          { wch: 15 },  // Receiver State
          { wch: 15 },  // Shipment Status
          { wch: 10 },  // Weight
          { wch: 14 },  // Custom Value
          { wch: 12 },  // Custom Currency
          { wch: 10 },  // Items
          { wch: 20 },  // Sender Name
          { wch: 15 },  // Sender Phone
          { wch: 35 },  // Sender Address
          { wch: 30 },  // Goods Description
          { wch: 22 },  // 1st OFD Date & Time
          { wch: 22 },  // Shipment Status Date & Time
          { wch: 12 },  // Delivery Attempts
          { wch: 22 },  // Delivered By (Rider)
          { wch: 30 },  // Rider Email
          { wch: 24 },  // Paid To (Wallet Owner)
          { wch: 30 },  // Wallet Email
          { wch: 14 },  // Delivery Rate
          { wch: 12 },  // Fine Amount
          { wch: 10 },  // Fine Days
          { wch: 18 },  // Amount Paid (Net)
          { wch: 20 },  // Export Date
        ];

        worksheet['!cols'] = colWidths;

        XLSX?.utils?.book_append_sheet(workbook, worksheet, 'Multi-Manifest Export');

        const fileName = `multi_manifest_export_${selectedManifests.length}_manifests_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX?.writeFile(workbook, fileName);

        toast.success(`Successfully exported ${response.data.data.total_shipments} shipments from ${response.data.data.manifests_count} manifests!`);

        // Clear selection after successful export
        setSelectedManifests([]);

      } else {
        toast.error('No data received from server');
      }
    } catch (error: any) {
      console.error('Export error:', error);
      toast.error(error?.response?.data?.message || 'Failed to export manifests');
    } finally {
      setIsExportingMultiple(false);
    }
  };


  const [destinationStates, setDestinationStates] = React.useState<any>([]);
  const [destinationBranches, setDestinationBranches] = React.useState<any>([]);
  const [selectedDestinationState, setSelectedDestinationState] = React.useState<string>('');
  const [allBranches, setAllBranches] = React.useState<any>([]);
  const [statusModal, setStatusModal] = React.useState<boolean>(false);

  const [shipmentId, setShipmentId] = React.useState<any>([]);
  // Load all branches for filtering

  // Re-check geofence when destination state changes
  React.useEffect(() => {
    if (selectedDestinationState && Object.keys(shipmentStates).length > 0) {
      const mismatches = Object.entries(shipmentStates)
        .filter(([_, state]) => state && state.toLowerCase() !== selectedDestinationState.toLowerCase())
        .map(([number]) => number);
      setGeofenceMismatches(mismatches);
    } else {
      setGeofenceMismatches([]);
    }
  }, [selectedDestinationState, shipmentStates]);

  const [delieveryInstruction, setDelieveryInstruction] = React.useState<string>('');
  function toggleStatus() {
    setStatusModal(true)
  }


  // Enhanced Filter State
  const [filters, setFilters] = React.useState<any>({
    start_date: '',
    end_date: '',
    sender_branch: '',        // Changed from sender_state
    destination_branch: '',   // Changed from destination_state
    created_by: '',
    type: 'all',
    audit_only: '',
    search: '',
    per_page: 15,
    page: 1
  });

  const [userData, setUserdata] = React.useState<any>({
    'manifest_name': "",
    'manifest_id': " ",
    'created_by': "",
    'sender_state': userLoginData?.data?.office || "", // Auto-fill from user's branch
    'destination_state': "",
    'shipment_status': "",
    'fleet_name': "null",
    'vehicle_name': "null",
    'goods_description': "null",
    'pcs': "null",
    'weight': "null",
    'fleet_price': 0,
    'custom_value': 0,
  });

  const [shipid, setShipId] = React.useState<any>({
    shipids: [],
  });

  const [shipWeight, setShipWeight] = React.useState<any>({
    shipWeights: 0,
  });


  const handleShipmentExport = () => {
    if (!manifestData || !manifestData.shipments || manifestData.shipments.length === 0) {
      toast.error('No shipments available to export');
      return;
    }

    setLoading(true);
    try {
      exportShipmentsToExcel(manifestData, manifestData.shipments);
    } catch (error) {
      toast.error('Export failed');
      console.error('Export error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDestinationStateChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedState = e.target.value;
    setSelectedDestinationState(selectedState);
    setDestinationBranches([]); // Clear previous branches

    if (selectedState) {
      try {
        const response: any = await SuperAdminApis.getBranchesByState(selectedState);
        if (response?.data?.status) {
          setDestinationBranches(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
        toast.error('Error loading branches for selected state');
      }
    }
  };


  const handleDestinationBranchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedBranch = e.target.value;
    setUserdata({ ...userData, destination_state: selectedBranch });
  };

  const [canBypassCode, setCanBypassCode] = React.useState<boolean>(false);
  const [permissions, setPermissions] = React.useState<any>(userLoginData?.data?.permissions ? JSON.parse(userLoginData?.data?.permissions) : ['']);


  React.useEffect(() => {
    permissions?.map((data: any, index: any) => {
      if (data === 'can_bypass_delivery_code' || userLoginData?.data?.role == 'admin') {
        setCanBypassCode(true);
      }
    })
  }, []);

  const statusOptions = STATUSTYPES?.map((datas: any) => ({
    value: datas?.EventName,
    label: datas?.EventName,
  }));




  // Create this separate component OUTSIDE the main component (before the RunwayManifest function)
  const StatusUpdateModalContent = React.memo(({
    shipmentId,
    userLoginData,
    statusOptions,
    canBypassCode,
    onClose,
    onSubmit
  }: any) => {
    const [shipmentStatus, setShipmentStatus] = React.useState<string>('');
    const [verOption, setVerOption] = React.useState<string>('');
    const [delieveryInstruction, setDelieveryInstruction] = React.useState<string>(shipmentId?.DeliveryInstructions || '');
    const [delieveryCode, setDelieveryCode] = React.useState<string>('');
    const [img1, setImg1] = React.useState('No selected file');
    const [img12, setImg12] = React.useState('empty');
    const [loading, setLoading] = React.useState(false);
    const [statusEventDateTime, setStatusEventDateTime] = React.useState<string>(getCurrentDateTimeLocal());

    function uploadImg1(e: any) {
      let size = (e.target.files[0].size / 1048576.0)
      if (e.target.files && e.target.files[0]) {
        if (size > 10) {
          if (e.target.name == 'uploadImg1') {
            e.target.value = ''
            toast.warn('Image too large')
          }
        }
        if (size <= 10) {
          if (e.target.name == 'uploadImg1') {
            setImg1(e.target.files[0]);
            setImg12(URL.createObjectURL(e.target.files[0]))
          }
        }
      }
    }

    const handleSearchChange = (selectedOption: any) => {
      setShipmentStatus(selectedOption ? selectedOption?.value : '');
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onSubmit({
        shipmentStatus,
        delieveryInstruction,
        delieveryCode,
        img1,
        setLoading,
        eventDateTime: statusEventDateTime
      });
    };

    return (
      <div style={{ height: '100%' }}>
        <div className="container bg-[#fff] rounded-lg p-2">
          <div className="px-3">
            <span className="flex justify-between px-2 pt-1">
              <p className='mt-2'>Change Status</p>
              <p className="cursor-pointer font-bold" onClick={onClose}>
                <SvgElement type={icontypesEnum.CANCEL} />
              </p>
            </span>

            <form className="pb-4 rounded-lg" onSubmit={handleFormSubmit}>
              <div className="relative w-full mt-5 mb-4">
                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                  Status : ({shipmentId?.Status})
                </label>

                <div>
                  {/* {userLoginData?.data?.role == 'fleet' || userLoginData?.data?.role == 'driver' ? */}
                  <select
                    required
                    name='SenderCountryCode'
                    value={shipmentStatus}
                    onChange={(e) => setShipmentStatus(e.target.value)}
                    className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2"
                  >
                    <option value="">--Select Status--</option>
                    <option value="Proof of Delivery">Proof of Delivery</option>
                    <option value="Attempted Delivery - Unable to Deliver - Other Reasons">Attempted Delivery - Unable to Deliver - Other Reasons</option>
                    {/* <option value="Attempt to Contact Consignee Failed">Attempt to Contact Consignee Failed</option> */}
                    {/* <option value="Not Delivered - Bad Weather Conditions">Not Delivered - Bad Weather Conditions</option> */}
                    {/* <option value="Attempted Delivery - No One Available/Home">Attempted Delivery - No One Available/Home</option> */}
                    {/* <option value="Attempted Delivery - Consignee Refused Delivery">Attempted Delivery - Consignee Refused Delivery</option> */}
                    {/* <option value="Attempted Delivery - Unable to Locate Consignee">Attempted Delivery - Unable to Locate Consignee</option> */}
                  </select>
                  {/* :
                     <Select
                       options={statusOptions}
                       onChange={handleSearchChange}
                       classNamePrefix="select"
                       isSearchable
                       placeholder="Filter by Status..."
                       isClearable
                     />
                   } */}


                  <div className="w-full lg:w-12/12 mt-2">
                    <div className="relative w-full mb-5">
                      <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                        Event Date/Time
                      </label>
                      <input
                        type="datetime-local"
                        value={statusEventDateTime}
                        onChange={(e) => setStatusEventDateTime(e.target.value)}
                        className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Set custom date/time for this status update.
                        Leave as current time for automatic timestamp.
                      </p>
                    </div>
                  </div>





                  <div>
                    <div className="w-full lg:w-12/12 mt-2">
                      <div className="relative w-full mb-5">
                        <label htmlFor="delivery-notes-input" className="block mb-2 text-sm font-semibold text-[#19213D]">
                          Delivery Notes
                        </label>
                        <textarea
                          // type="text"
                          id="delivery-notes-input"
                          name="DeliveryInstructions"
                          required
                          value={delieveryInstruction}
                          onChange={(e) => setDelieveryInstruction(e.target.value)}
                          className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                          placeholder="Write here..."
                          autoComplete="off"
                        >
                        </textarea>
                      </div>
                    </div>

                    {((shipmentStatus == 'Proof of Delivery' || shipmentId?.Status == 'Proof of Delivery') && !canBypassCode) ?
                      <div>
                        <label className="block mb-2 text-sm font-semibold text-[#19213D]">Select Proof Option</label>
                        <select
                          onChange={(e) => setVerOption(e.target.value)}
                          className="bg-white mb-3 border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2"
                        >
                          <option value=''>Please Select</option>
                          <option value="image">Photo Upload</option>
                          <option value="code">Code</option>
                        </select>

                        {verOption == 'image' ?
                          (img1 !== 'No selected file' && verOption == 'image' ?
                            <div className="flex flex-col" style={{ border: '1px #E8E8E8 solid', borderRadius: '5px', padding: '5px 5px', marginBottom: '10px' }}>
                              <div className='flex justify-end'>
                                <label style={{ paddingTop: "4px", cursor: 'pointer' }}>
                                  <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/jpeg" name='uploadImg1' type="file" />
                                  <SvgElement type={icontypesEnum.EDITPEN} />
                                </label>
                                <span className='ml-2' onClick={() => setImg1("No selected file")} style={{ cursor: 'pointer' }}>
                                  <svg width="24" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 8.00008H6.66667M6.66667 8.00008H28M6.66667 8.00008V26.6668C6.66667 27.374 6.94762 28.0523 7.44772 28.5524C7.94781 29.0525 8.62609 29.3334 9.33333 29.3334H22.6667C23.3739 29.3334 24.0522 29.0525 24.5523 28.5524C25.0524 28.0523 25.3333 27.374 25.3333 26.6668V8.00008H6.66667ZM10.6667 8.00008V5.33342C10.6667 4.62617 10.9476 3.94789 11.4477 3.4478C11.9478 2.9477 12.6261 2.66675 13.3333 2.66675H18.6667C19.3739 2.66675 20.0522 2.9477 20.5523 3.4478C21.0524 3.94789 21.3333 4.62617 21.3333 5.33342V8.00008M13.3333 14.6667V22.6668M18.6667 14.6667V22.6668" stroke="#EB0046" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                              </div>
                              <span className="flex justify-start">
                                <img src={img12} alt="" style={{ width: '100%', height: '150px' }} />
                              </span>
                            </div>
                            :
                            <div className="w-full lg:w-12/12 mt-2">
                              <label style={{ cursor: 'pointer' }}>
                                <svg width="300" height="103" viewBox="0 0 478 103" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="1" y="1.5" width="476" height="100" rx="8" fill="#F9FAFB" />
                                  <rect x="1" y="1.5" width="476" height="100" rx="8" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" strokeDasharray="5 5" />
                                  <text fill="#6B7280" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="14" fontWeight="600" letterSpacing="0em"><tspan x="191.143" y="69.0909">Click to Upload</tspan></text>
                                  <text fill="#6B7280" xmlSpace="preserve" style={{ whiteSpace: 'pre' }} fontFamily="Inter" fontSize="12" letterSpacing="0em"><tspan x="177.096" y="93.3636">PNG, JPG(MAX. 500KB)</tspan></text>
                                </svg>
                                <input className="hidden" onChange={uploadImg1} accept="image/x-png,image/gif,image/jpeg" name='uploadImg1' type="file" />
                              </label>
                            </div>
                          )
                          : ''
                        }

                        {verOption == 'code' ?
                          <div className="w-full lg:w-12/12">
                            <div className="relative w-full mb-5">
                              <label className="block mb-2 text-sm font-semibold text-[#19213D]">Delivery Code</label>
                              <input
                                required
                                onChange={(e) => setDelieveryCode(e.target.value)}
                                value={delieveryCode}
                                className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-[5px] block w-full p-3"
                                placeholder="Write here..."
                              />
                            </div>
                          </div>
                          : ''
                        }
                      </div>
                      : ''
                    }
                  </div>
                </div>
              </div>

              <span className="flex justify-center pt-4">
                <button
                  type="submit"
                  disabled={loading}
                  style={{ borderRadius: '50px', color: '#F52424' }}
                  className="text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full px-2 py-2.5 text-center"
                >
                  <div className="flex justify-center gap-3">
                    <span>Update</span>
                    <Oval
                      visible={loading}
                      height="20"
                      width="20"
                      color="#E04343"
                      secondaryColor="#FCBF94"
                      ariaLabel="oval-loading"
                    />
                  </div>
                </button>
              </span>

              <span className="flex justify-center pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  style={{ borderRadius: '50px' }}
                  className="text-black focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm w-full px-2 py-1.5 text-center"
                >
                  Cancel
                </button>
              </span>
            </form>
          </div>
        </div>
      </div>
    );
  });

  StatusUpdateModalContent.displayName = 'StatusUpdateModalContent';


  // Enhanced API Call Function
  const fetchManifests = React.useCallback(async (filterParams?: any) => {
    setScreenLoader(true);
    const currentFilters = filterParams || filters;

    try {
      let response: any;
      // Use enhanced API for all roles, not just admin/fleet/driver
      console.log('Fetching manifests with filters:', currentFilters);
      response = await SuperAdminApis.getAllManifest({
        search: currentFilters.search,
        start_date: currentFilters.start_date,
        end_date: currentFilters.end_date,
        sender_state: currentFilters.sender_state,
        destination_state: (currentFilters.destination_state || ""),
        type: currentFilters.type,
        audit_only: currentFilters.audit_only,
        created_by: currentFilters.created_by,
        per_page: currentFilters.per_page,
        page: currentFilters.page
      });

      if (response?.data?.status) {
        setUserList(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching manifests:', error);
      toast.error('Failed to fetch manifests');
    } finally {
      setScreenLoader(false);
    }
  }, [userLoginData, filters]);


  React.useEffect(() => {
    fetchManifests();
  }, [filters]);

  // Filter Handlers
  // const handleFiltersChange = (newFilters: any) => {
  //   console.log(newFilters);
  //   setFilters({ ...filters, ...newFilters, page: 1 });
  // };

  const handleFiltersChange = (newFilters: any) => {
    setFilters((prevFilters: any) => ({ ...prevFilters, ...newFilters, page: 1 }));
  };


  const handleApplyFilters = (filtersToApply?: any) => {
    if (filtersToApply) {
      // Use the filters passed directly from the filter component
      fetchManifests(filtersToApply);
    } else {
      // Use current state filters (fallback)
      fetchManifests();
    }
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      start_date: '',
      end_date: '',
      sender_state: '',
      destination_state: '',
      created_by: '',
      type: 'all',
      search: '',
      per_page: 15,
      page: 1
    };
    setFilters(clearedFilters);
    // Pass cleared filters directly to avoid async state issue
    fetchManifests(clearedFilters);
  };

  // Enhanced Export Function
  const handleExport = async () => {
    try {
      setLoading(true);

      let exportData;
      if (userLoginData?.data?.role === 'admin' || userLoginData?.data?.role === 'fleet' || userLoginData?.data?.role === 'driver') {
        exportData = userLists?.data || [];
      } else {
        exportData = userLists?.data || [];
        // exportData = userLists?.[shipType]?.data || [];
      }

      exportToExcel(exportData);
      toast.success('Export completed successfully!');
    } catch (error) {
      toast.error('Export failed');
    } finally {
      setLoading(false);
    }
  };

  const validateShipmentNumbers = React.useCallback(async (barcodes: string[]) => {
    if (barcodes.length === 0) {
      setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
      setValidationResults({});
      return;
    }

    setIsValidating(true);

    try {
      // Check for duplicates in the scanned list
      const duplicateCheck: { [key: string]: number } = {};
      const newValidationResults: { [key: string]: 'valid' | 'invalid' | 'duplicate' } = {};

      barcodes.forEach(barcode => {
        if (barcode.trim()) {
          duplicateCheck[barcode] = (duplicateCheck[barcode] || 0) + 1;
        }
      });

      // Mark duplicates
      Object.keys(duplicateCheck).forEach(barcode => {
        if (duplicateCheck[barcode] > 1) {
          newValidationResults[barcode] = 'duplicate';
        }
      });

      // Validate against database (call your API)
      const uniqueBarcodes = barcodes.filter((barcode, index, arr) =>
        arr.indexOf(barcode) === index && barcode.trim() !== ''
      );

      if (uniqueBarcodes.length > 0) {
        const response = await SuperAdminApis.validateShipmentNumbers(uniqueBarcodes);

        if (response?.data?.status) {
          const validShipments = response.data?.data?.validShipments || [];
          const validDetails = response.data?.data?.validShipmentsDetail || [];
          const invalidShipments = response.data.data.invalidShipments || [];

          // Track receiver states from enriched data (for geofencing)
          const stateMap: { [key: string]: string } = {};
          validDetails.forEach((item: any) => {
            stateMap[item.shipment_number] = item.receiver_add_state || '';
          });
          setShipmentStates(prev => ({ ...prev, ...stateMap }));

          // Existing validation logic (uses flat string array)
          validShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'valid';
            }
          });

          invalidShipments.forEach((shipment: string) => {
            if (newValidationResults[shipment] !== 'duplicate') {
              newValidationResults[shipment] = 'invalid';
            }
          });

          // Check geofence mismatches
          if (selectedDestinationState) {
            const mismatches = Object.entries(stateMap)
              .filter(([_, state]) => state && state.toLowerCase() !== selectedDestinationState.toLowerCase())
              .map(([number]) => number);
            setGeofenceMismatches(mismatches);
          }
        }
      }

      // Calculate stats
      const stats = {
        total: barcodes.filter(b => b.trim()).length,
        valid: Object.values(newValidationResults).filter(status => status === 'valid').length,
        invalid: Object.values(newValidationResults).filter(status => status === 'invalid').length,
        duplicates: Object.values(newValidationResults).filter(status => status === 'duplicate').length
      };

      setValidationResults(newValidationResults);
      setScannerStats(stats);

    } catch (error) {
      console.error('Validation error:', error);
      toast.error('Failed to validate shipment numbers');
    } finally {
      setIsValidating(false);
    }
  }, []);

  // Existing functions with minor updates
  const handleBarcodeListChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const updatedValues = newValue
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item !== "");

    setBarcodeValues(updatedValues);

    // Debounce validation to avoid too many API calls
    if (validationTimeout) {
      clearTimeout(validationTimeout);
    }

    const timeout = setTimeout(() => {
      validateShipmentNumbers(updatedValues);
    }, 500);

    setValidationTimeout(timeout);
  }, [validateShipmentNumbers, validationTimeout]);


  const handleInputChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Input change:', e.target.value);
    setCurrentInput(e.target.value);
  }, []);

  const handleKeyPress = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    console.log('Key pressed:', e.key);
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      const value = currentInput.trim();
      if (value && !barcodeValues.includes(value)) {
        const newBarcodeValues = [...barcodeValues, value];
        setBarcodeValues(newBarcodeValues);
        setCurrentInput("");

        // Immediate validation for single new item
        validateShipmentNumbers(newBarcodeValues);
      } else {
        setCurrentInput("");
      }
    }
  }, [currentInput, barcodeValues, validateShipmentNumbers]);



  // Add a new function to handle adding barcode
  const handleAddBarcode = React.useCallback(() => {
    const value = currentInput.trim();
    if (value && !barcodeValues.includes(value)) {
      const newBarcodeValues = [...barcodeValues, value];
      setBarcodeValues(newBarcodeValues);
      setCurrentInput("");
      validateShipmentNumbers(newBarcodeValues);
    } else if (value) {
      setCurrentInput("");
    }
  }, [currentInput, barcodeValues, validateShipmentNumbers]);

  // Add form submit handler
  const handleBarcodeFormSubmit = React.useCallback((e: React.FormEvent) => {
    e.preventDefault();
    handleAddBarcode();
  }, [handleAddBarcode]);



  const getValidationColor = React.useCallback((barcode: string) => {
    const status = validationResults[barcode];
    switch (status) {
      case 'valid': return 'text-green-600 bg-green-50';
      case 'invalid': return 'text-red-600 bg-red-50';
      case 'duplicate': return 'text-yellow-600 bg-yellow-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  }, [validationResults]);



  const handleChange2 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFleetData2({ ...fleetData2, [name]: value });

    if (name == 'shipment_status') {
      setFleetData2({ ...fleetData2, [name]: value });
      STATUSTYPES?.filter((data: any) => data?.EventName == value)?.map((datas: any, index: any) => {
        setShipmentStatusId(datas?.EventCode)
        setFleetData2({ ...fleetData2, 'status_id': datas?.EventCode, shipment_status: value });
      })
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setUserdata({ ...userData, [name]: value });
  };

  const getCurrentDateTime = (): string => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const isAM = hours < 12;
    const formattedHours = (hours % 12 || 12).toString();
    const period = isAM ? 'am' : 'pm';
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    return `${formattedHours}:${minutes}:${seconds}`;
  };


  const [scannerStats, setScannerStats] = useState({
    total: 0,
    valid: 0,
    invalid: 0,
    duplicates: 0
  });





  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setRejectedNo('');

    // Filter to only include valid shipments
    const validShipments = barcodeValues.filter(barcode =>
      validationResults[barcode] === 'valid'
    );

    if (validShipments.length === 0) {
      toast.error('No valid shipments to add to manifest');
      setLoading(false);
      return;
    }

    if (validShipments.length !== barcodeValues.length) {
      const invalidCount = barcodeValues.length - validShipments.length;
      toast.warning(`${invalidCount} invalid/duplicate shipments will be excluded from manifest`);
    }

    try {
      const batches = [];
      const FRONTEND_BATCH_SIZE = 20; // Increased from 10 to 100
      for (let i = 0; i < validShipments.length; i += FRONTEND_BATCH_SIZE) {
        batches.push(validShipments.slice(i, i + FRONTEND_BATCH_SIZE));
      }

      let pics: any = 0;
      let wgt: any = 0;
      let count: any = 1;
      let randCode = Math.floor(Math.random() * Date.now()).toString(32);
      let manifestName = (userData?.manifest_name + '(' + getCurrentDateTime() + ')');

      for (const batch of batches) {
        const formData = new FormData()
        formData.append('manifest_name', manifestName)
        formData.append('manifest_id', randCode)
        formData.append('airwaybill_number_id', selectedAirwaybillNumber?.airwaybill_number || '')
        formData.append('created_by', userLoginData?.data?.email)
        formData.append('sender_state', userLoginData?.data?.office)
        formData.append('sender_branch', userLoginData?.data?.branch)
        formData.append('destination_state', (userData?.destination_state))
        formData.append('destination_branch', userData?.destination_state)
        formData.append('shipment_status', userData?.shipment_status)
        formData.append('status_id', STATUSTYPES.find((data) => data?.EventName === userData?.shipment_status)?.EventCode || '')
        formData.append('fleet_name', shipmentRider?.target?.value)
        formData.append('fleet_price', userData?.fleet_price)
        formData.append('shipment_ids', batch?.toString())
        formData.append('vehicle_name', userData?.vehicle_name)
        formData.append('goods_description', userData?.goods_description)
        formData.append('pics', pics)
        formData.append('weight', wgt)
        formData.append('custom_value', userData?.custom_value)
        formData.append('event_datetime', eventDateTime)
        formData.append('dead_line', deadLine)
        formData.append('manifest_type', manifestType)
        formData.append('is_audit_only', isAuditOnly ? '1' : '0')

        const response: any = await SuperAdminApis.createManifest(formData);
        if (!response.data.status) {
          throw new Error(response.data.message || 'Batch processing failed.');
        }

        let countedPics = parseInt(response?.data?.data?.pcs, 10);
        let countedWeight = parseFloat(response?.data?.data?.weight);
        pics = countedPics
        wgt = countedWeight
        count += 1

        if ((response?.data?.rejected_no)?.length >= 1) {
          setRejectedNo((response?.data?.rejected_no).toString())
        }

        const percentage = ((count - 1) / batches.length) * 100;
        setPercentage(percentage.toFixed(1));
      }

      // Refresh the manifest list
      fetchManifests();
      toast.success(`Manifest Created Successfully with ${validShipments.length} shipments!`);
      setEventDateTime(getCurrentDateTimeLocal());
    } catch (error: any) {
      // 🔄 MANIFEST-BLOCKING — Handle 422 (all shipments blocked)
      if (error?.response?.status === 422 && error?.response?.data?.error === 'ALL_SHIPMENTS_BLOCKED') {
        const blockedData = error.response.data;
        const blockedCount = blockedData.transition_blocked_count || 0;
        const blockedShipments = blockedData.transition_blocked_shipments || [];

        // Build a readable summary of why shipments were blocked
        const reasons = blockedShipments.slice(0, 3).map(
          (s: any) => `${s.number}: ${s.current_status} → ${s.attempted_status} (${s.reason})`
        );
        const moreCount = blockedShipments.length - 3;

        toast.error(
          `Manifest not created — all ${blockedCount} shipment(s) were blocked due to invalid status transitions.`

        );

        if (reasons.length > 0) {
          toast(
            reasons.join('\n') + (moreCount > 0 ? `\n...and ${moreCount} more` : ''),
            { icon: '🚫' }
          );
        }
      } else {
        toast.error(`Error: ${error?.response?.data?.message || error.message}`);
      }
    } finally {
      setLoading(false)
      setPercentage(0)
      setAddModal(false)
      setDeadLine('')
      setUserdata({
        'manifest_name': "",
        'manifest_id': " ",
        'created_by': "",
        'sender_state': "",
        'destination_state': "",
        'shipment_status': "",
        'fleet_name': "null",
        'vehicle_name': "null",
        'goods_description': "null",
        'pcs': "null",
        'weight': "null",
        'fleet_price': 0,
        'custom_value': 0,
      });
      setShipmentRider('')
      setBarcodeValues([])
      setValidationResults({})
      setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 })
      setManifestType('fleet')
      setShipmentStates({})
      setGeofenceMismatches([])
      setIsAuditOnly(false)
    }
  };


  const batchUpdateManifestShipments = async (
    manifestId: string,
    shipmentNumbers: string[],
    newStatus: string,
    statusId: string,
    eventDateTime: string,
    onProgressUpdate: (progress: number) => void,
    onBatchInfoUpdate: (info: any) => void,
    onComplete: () => void,
    onError: (error: string) => void
  ) => {
    const BATCH_SIZE = 100;
    const batches: string[][] = [];

    // Split shipments into batches of 10
    for (let i = 0; i < shipmentNumbers.length; i += BATCH_SIZE) {
      batches.push(shipmentNumbers.slice(i, i + BATCH_SIZE));
    }

    const totalBatches = batches.length;
    let totalUpdated = 0;
    let totalFailed = 0;

    console.log(`Starting batch update: ${shipmentNumbers.length} shipments in ${totalBatches} batches`);

    try {
      for (let i = 0; i < batches.length; i++) {
        const batch = batches[i];
        const batchNumber = i + 1;

        console.log(`Processing batch ${batchNumber}/${totalBatches} with ${batch.length} shipments`);

        // Update progress
        const progress = ((i) / totalBatches) * 100;
        onProgressUpdate(progress);
        onBatchInfoUpdate({
          currentBatch: batchNumber,
          totalBatches: totalBatches,
          updatedCount: totalUpdated,
          failedCount: totalFailed,
          totalShipments: shipmentNumbers.length
        });

        try {
          // Call API for this batch
          const response: any = await SuperAdminApis.batchUpdateManifestShipments({
            manifest_id: manifestId,
            shipment_numbers: batch,
            new_status: newStatus,
            status_id: statusId,
            batch_number: batchNumber,
            total_batches: totalBatches,
            event_datetime: eventDateTime
          });

          if (response?.data?.status) {
            totalUpdated += response.data.data.updated_count || 0;
            totalFailed += response.data.data.failed_count || 0;

            console.log(`Batch ${batchNumber} complete:`, {
              updated: response.data.data.updated_count,
              failed: response.data.data.failed_count,
              datetime_info: response.data.data.datetime_info
            });
          } else {
            totalFailed += batch.length;
            console.error(`Batch ${batchNumber} failed:`, response?.data?.message);
          }
        } catch (batchError: any) {
          totalFailed += batch.length;
          console.error(`Batch ${batchNumber} error:`, batchError.message);
        }

        // Small delay between batches
        if (i < batches.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 300));
        }
      }

      // Final progress update
      onProgressUpdate(100);
      onBatchInfoUpdate({
        currentBatch: totalBatches,
        totalBatches: totalBatches,
        updatedCount: totalUpdated,
        failedCount: totalFailed,
        totalShipments: shipmentNumbers.length
      });

      console.log('Batch update complete:', { totalUpdated, totalFailed });

      // Show completion message
      if (totalFailed === 0) {
        toast.success(`Successfully updated all ${totalUpdated} shipments!`);
      } else {
        toast.warning(`Updated ${totalUpdated} shipments, ${totalFailed} failed.`);
      }

      onComplete();

    } catch (error: any) {
      console.error('Batch update failed:', error);
      onError(error.message || 'Batch update failed');
    }
  };



  const updateManifest = React.useCallback(
    async (e: React.ChangeEvent<HTMLFormElement>) => {
      e.preventDefault();
      setLoading(true);
      setUpdateProgress(0);

      const formData = fleetData2;
      const newStatus = formData?.shipment_status;

      // Get status_id for the new status
      const statusId = STATUSTYPES?.find((data: any) => data?.EventName === newStatus)?.EventCode || '';

      try {
        // Step 1: Update manifest metadata first
        console.log('Step 1: Updating manifest metadata...');
        const metadataResponse: any = await SuperAdminApis.updateManifestMetadata(fleetData2?.id, formData);

        if (!metadataResponse?.data?.status) {
          throw new Error(metadataResponse?.data?.message || 'Failed to update manifest metadata');
        }

        console.log('Metadata update response:', metadataResponse.data);

        // Step 2: Check if we need batch processing for shipments
        const {
          status_changed,
          shipment_numbers,
          total_shipments,
        } = metadataResponse.data;

        if (status_changed && total_shipments > 0 && shipment_numbers?.length > 0) {
          // Need to batch update shipments
          console.log(`Step 2: Batch updating ${total_shipments} shipments...`);
          setIsUpdatingBatch(true);

          await batchUpdateManifestShipments(
            fleetData2?.manifest_id,
            shipment_numbers,
            newStatus,
            statusId,
            statusUpdateDateTime,
            (progress) => setUpdateProgress(progress),
            (info) => setUpdateBatchInfo(info),
            () => {
              // On complete
              setRiderModal(false);
              setIsUpdatingBatch(false);
              setLoading(false);
              setStatusUpdateDateTime(getCurrentDateTimeLocal());
              fetchManifests(); // Refresh the list
            },
            (error: string) => {
              // On error
              toast.error(`Batch update error: ${error}`);
              setIsUpdatingBatch(false);
              setLoading(false);
            }
          );
        } else {
          // No batch processing needed (status didn't change or no shipments)
          toast.success(metadataResponse?.data?.message || 'Manifest updated successfully');
          setRiderModal(false);
          setLoading(false);
          fetchManifests();
        }

      } catch (error: any) {
        console.error('Update manifest error:', error);
        toast.error(error.message || 'Failed to update manifest');
        setLoading(false);
        setIsUpdatingBatch(false);
      }
    },
    [fleetData2, fetchManifests, statusUpdateDateTime]
  );

  const nextPage = React.useCallback((id: any) => {
    setShipmentSearchText('');
    setActiveStatusFilter(null);
    setScreenLoader(true); // Add loading state
    setNextPageId(id)
    SuperAdminApis.getSingleManifest(id).then(
      (response: AxiosResponse<any>) => {
        console.log('Single manifest response:', response?.data); // Debug log
        if (response?.data?.status && response?.data?.data) {
          setManifestData(response?.data?.data);
          setTabNo('2'); // Ensure it's a string to match the condition
        } else {
          console.error('Failed to fetch manifest details:', response?.data?.message);
          toast.error('Failed to load manifest details');
        }
      }
    ).catch(function (error) {
      console.error('Error fetching single manifest:', error);
      toast.error('Error loading manifest details');
    }).finally(() => {
      setScreenLoader(false);
    })
  }, []);

  const getAllVehicles = React.useCallback((id: any) => {
    const query: any = {
      search: searchText,
    };
    SuperAdminApis.getAllVehicle('', query, id).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setVehicle(response?.data?.data?.data)
        }
      }
    ).catch(function (error) {
      // handle error
    })
  }, [vehicle]);

  const selectShipment = (e: any, datas: any) => {
    const { value, checked } = e.target;
    const { shipids } = shipid;

    if (checked) {
      setBarcodeValues((prev) => [...prev, value]);
      setShipId({
        shipids: [...shipids, value],
      });
    } else {
      setBarcodeValues((prev) => prev.filter((e: any) => e !== value));
      setShipId({
        shipids: shipids.filter((e: any) => e !== value)
      });
    }
  };

  const handleDownloadClick = (id: string) => {
    totalWgt = 0;
    setLoadingDocId(id);
  };

  const resetLoading = () => {
    setLoadingDocId(null);
  };

  const paginator = React.useCallback(
    (value: any) => {
      const newFilters = { ...filters, page: value || 1 };
      setFilters(newFilters);
      fetchManifests(newFilters);
    }, [filters, fetchManifests]);

  const paginatorForOffice = React.useCallback(
    (value: any, type: any) => {
      let value1 = 1;
      let value2 = 1;
      if (value !== null && type == 'out_bound') {
        value1 = value;
        value2 = 1;
      } else if (value !== null && type == 'in_bound') {
        value1 = 1;
        value2 = value;
      }

      SuperAdminApis.getAllManifestByOffice(value1, value2, { search: searchText }).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setUserList(response?.data?.data)
            setScreenLoader(false)
          }
        }
      ).catch(function (error) {
        console.log(error.response.data);
      })
    }, [userLists, screenLoader, searchText]);

  // Initial load and setup
  React.useEffect(() => {
    const query: any = {
      search: searchText,
    };
    setScreenLoader(true);

    // Load riders
    SuperAdminApis.getAllRiders('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setRiders(response?.data?.data?.data)
          // console.log('Riders loaded:', response?.data?.data?.data);
        }
      }
    ).catch(function (error) {
      // handle error
    })


    // Load fleets
    SuperAdminApis.getAllFleetsForDropdown().then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setFleetData(response?.data?.data)
        }
      }
    ).catch(function (error) {
      // handle error
    })

    // Load destination states from branches
    SuperAdminApis.getStatesFromBranches().then(
      (response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setDestinationStates(response?.data?.data);
        }
      }
    ).catch(function (error) {
      console.error('Error loading destination states:', error);
    })

    // Load all branches for filtering
    SuperAdminApis.getAllBranchesSimple().then(
      (response: AxiosResponse<any>) => {
        if (response?.data?.status) {
          setAllBranches(response?.data?.data);
        }
      }
    ).catch(function (error) {
      console.error('Error loading branches:', error);
    })

    // Load shipments for manifest creation
    SuperAdminApis.getAllShipments('', '', '').then(
      (response: any) => {
        if (response?.data) {
          setShipmentInfo(response?.data?.out_bound?.data);
          setmanifestListData(response?.data?.manifest)
        }
      }
    )

    // Load manifests with initial filters
    fetchManifests();
  }, []);



  // ==================== AIRWAYBILL NUMBER FUNCTIONS ====================

  /**
   * Load airwaybill numbers for dropdown
   */
  const loadAirwaybillNumbers = React.useCallback(async () => {
    try {
      setAirwaybillLoading(true);
      const response = await SuperAdminApis.getAirwaybillNumbersDropdown();
      if (response?.data?.status) {
        setAirwaybillNumbers(response.data.data);
      }
    } catch (error: any) {
      console.error('Error loading airwaybill numbers:', error);
      toast.error('Failed to load airwaybill numbers');
    } finally {
      setAirwaybillLoading(false);
    }
  }, []);

  /**
   * Load all airwaybill numbers for management drawer
   */
  const loadAllAirwaybillNumbers = React.useCallback(async () => {
    try {
      setAirwaybillLoading(true);
      const response = await SuperAdminApis.getAllAirwaybillNumbers({
        search: airwaybillSearchTerm,
        status: 'all',
        per_page: 100
      });
      if (response?.data?.status) {
        setAirwaybillNumbers(response.data.data.data || response.data.data);
      }
    } catch (error: any) {
      console.error('Error loading all airwaybill numbers:', error);
      toast.error('Failed to load airwaybill numbers');
    } finally {
      setAirwaybillLoading(false);
    }
  }, [airwaybillSearchTerm]);

  /**
   * Create new airwaybill number
   */
  const handleCreateAirwaybillNumber = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!airwaybillFormData.airwaybill_number.trim()) {
      toast.error('Airwaybill number is required');
      return;
    }

    try {
      setAirwaybillLoading(true);
      const response = await SuperAdminApis.createAirwaybillNumber(airwaybillFormData);

      if (response?.data?.status) {
        toast.success('Airwaybill number created successfully!');
        setShowAirwaybillCreateModal(false);

        // Reset form
        setAirwaybillFormData({
          airwaybill_number: '',
          description: '',
          status: 'active'
        });

        // Reload airwaybill numbers
        await loadAirwaybillNumbers();

        // Auto-select the newly created airwaybill number
        setSelectedAirwaybillNumber(response.data.data);
        setUserdata({ ...userData, airwaybill_number_id: response.data.data.airwaybill_number });
      } else {
        toast.error(response?.data?.message || 'Failed to create airwaybill number');
      }
    } catch (error: any) {
      console.error('Error creating airwaybill number:', error);
      toast.error(error?.response?.data?.message || 'Failed to create airwaybill number');
    } finally {
      setAirwaybillLoading(false);
    }
  };

  /**
   * Update airwaybill number
   */
  const handleUpdateAirwaybillNumber = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!editingAirwaybill) return;

    try {
      setAirwaybillLoading(true);
      const response = await SuperAdminApis.updateAirwaybillNumber(
        editingAirwaybill.id,
        airwaybillFormData
      );

      if (response?.data?.status) {
        toast.success('Airwaybill number updated successfully!');
        setEditingAirwaybill(null);

        // Reset form
        setAirwaybillFormData({
          airwaybill_number: '',
          description: '',
          status: 'active'
        });

        // Reload airwaybill numbers
        if (showAirwaybillDrawer) {
          await loadAllAirwaybillNumbers();
        } else {
          await loadAirwaybillNumbers();
        }
      } else {
        toast.error(response?.data?.message || 'Failed to update airwaybill number');
      }
    } catch (error: any) {
      console.error('Error updating airwaybill number:', error);
      toast.error(error?.response?.data?.message || 'Failed to update airwaybill number');
    } finally {
      setAirwaybillLoading(false);
    }
  };

  /**
   * Delete airwaybill number
   */
  const handleDeleteAirwaybillNumber = async (id: number) => {
    if (!window.confirm('Are you sure you want to delete this airwaybill number?')) {
      return;
    }

    try {
      setAirwaybillLoading(true);
      const response = await SuperAdminApis.deleteAirwaybillNumber(id);

      if (response?.data?.status) {
        toast.success('Airwaybill number deleted successfully!');

        // Reload airwaybill numbers
        if (showAirwaybillDrawer) {
          await loadAllAirwaybillNumbers();
        } else {
          await loadAirwaybillNumbers();
        }

        // Clear selection if deleted number was selected
        if (selectedAirwaybillNumber?.id === id) {
          setSelectedAirwaybillNumber(null);
          setUserdata({ ...userData, airwaybill_number_id: null });
        }
      } else {
        toast.error(response?.data?.message || 'Failed to delete airwaybill number');
      }
    } catch (error: any) {
      console.error('Error deleting airwaybill number:', error);
      toast.error(error?.response?.data?.message || 'Failed to delete airwaybill number');
    } finally {
      setAirwaybillLoading(false);
    }
  };

  /**
   * Start editing an airwaybill number
   */
  const startEditingAirwaybill = (airwaybill: any) => {
    setEditingAirwaybill(airwaybill);
    setAirwaybillFormData({
      airwaybill_number: airwaybill.airwaybill_number,
      description: airwaybill.description || '',
      status: airwaybill.status
    });
    setShowAirwaybillCreateModal(true);
  };

  /**
   * Cancel editing
   */
  const cancelEditingAirwaybill = () => {
    setEditingAirwaybill(null);
    setAirwaybillFormData({
      airwaybill_number: '',
      description: '',
      status: 'active'
    });
    setShowAirwaybillCreateModal(false);
  };

  // Load airwaybill numbers on component mount
  React.useEffect(() => {
    loadAirwaybillNumbers();
  }, [loadAirwaybillNumbers]);

  // Reload when drawer is opened
  React.useEffect(() => {
    if (showAirwaybillDrawer) {
      loadAllAirwaybillNumbers();
    }
  }, [showAirwaybillDrawer, loadAllAirwaybillNumbers]);

  // Enhanced Table Component
  const ManifestTable = () => (
    <>
      {/* Desktop Table View - Hidden on mobile */}
      <div className="hidden lg:block relative overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
          <thead className="text-[12px] text-[#030229] bg-[#FAFAFA]">
            <tr>
              <th scope="col" className="px-2 py-2">
                <input
                  type="checkbox"
                  checked={selectedManifests.length === userLists?.data?.length && userLists?.data?.length > 0}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  className="w-4 h-4 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer"
                />
              </th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">S/N</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Manifest Name</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Manifest ID</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">AirwayBill No.</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Origin Branch</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap w-[120px]">Destination Branch</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Date Created</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Created By</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Status</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Fleet</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Shipments</th>
              <th scope="col" className="px-2 py-2 whitespace-nowrap">Description</th>
              <th scope="col" className="px-8 py-4">Action</th>
            </tr>
          </thead>
          <tbody>
            {userLists?.data?.length > 0 ? (
              userLists?.data?.map((manifest: any, index: number) => (
                <tr key={manifest.id} className={`${selectedManifests.includes(manifest.id) ? 'bg-purple-50' : 'bg-white'}`}>
                  <td className="px-2 py-2">
                    <input
                      type="checkbox"
                      checked={selectedManifests.includes(manifest.id)}
                      onChange={(e) => handleManifestSelection(manifest.id, e.target.checked)}
                      className="w-4 h-4 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer"
                    />
                  </td>
                  <td className="px-2 py-2">{index + 1}</td>
                  {/* Rest of your existing table cells remain the same */}
                  <td className="px-2 py-4 whitespace-nowrap font-medium">{manifest.manifest_name}</td>
                  <td className="px-2 py-4 whitespace-nowrap">{manifest.manifest_id}</td>
                  <td className="px-2 py-4 whitespace-nowrap">{manifest.airwaybill_number_id ? manifest.airwaybill_number_id : '--'}</td>
                  <td className="px-2 py-4 whitespace-nowrap">{manifest.sender_branch}</td>
                  <td className="px-2 py-4 whitespace-nowrap">{manifest.destination_branch}</td>
                  <td className="px-2 py-4 whitespace-nowrap">
                    <div className="text-sm">
                      {convertUTCDateToLocalDate(manifest.created_at)}
                    </div>
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap">
                    <div>
                      <div className="font-medium text-gray-900">{manifest.created_by || 'N/A'}</div>
                    </div>
                  </td>
                  <td className="px-2 py-4 truncate max-w-32 whitespace-nowrap">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {manifest.shipment_status}
                    </span>
                    {manifest.is_audit_only && (
                      <span
                        className="ml-1 inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-800 border border-amber-300"
                        title="Audit only — shipment statuses were not changed by this manifest"
                      >
                        AUDIT
                      </span>
                    )}
                  </td>
                  <td className="px-2 py-4 whitespace-nowrap">{manifest.fleet_name}</td>
                  <td className="px-2 py-4 truncate max-w-32">
                    {/* Number of SHIPMENTS on the manifest. This used to render
                        `manifest.pcs`, which is the total piece count — so a
                        manifest holding one shipment of 45 pieces displayed
                        "45 items" under a column headed "Shipments". Prefer the
                        server's shipments_count; fall back to the eager-loaded
                        relation so this stays correct if the API is older. */}
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {manifest.shipments_count ?? manifest.shipments?.length ?? 0} shipments
                    </span>
                  </td>
                  <td className="px-2 py-4 truncate max-w-32 whitespace-nowrap" title={manifest.goods_description}>
                    {manifest.goods_description}
                  </td>
                  <td className='flex justify-between gap-3 px-6 py-4 whitespace-nowrap'>
                    {/* Rest of your existing action buttons remain the same */}
                    {/* {userLoginData?.data?.role !== 'fleet' && userLoginData?.data?.role !== 'driver' && (
                      <span
                        className="hover:underline text-blue-500 cursor-pointer text-xs"
                        onClick={() => { setRiderModal(true); setFleetData2(manifest) }}
                      >
                        Confirm
                      </span>
                    )} */}

                    <div>
                      {loadingDocId === manifest.id ? (
                        <PDFDownloadLink
                          document={<ShipmentManifest data={manifest} />}
                          fileName={`manifest_${manifest.manifest_id}.pdf`}
                        >
                          {({ loading }) =>
                            loading ? (
                              <span className="text-xs">Loading...</span>
                            ) : (
                              <span className="hover:underline text-blue-500 cursor-pointer text-xs">
                                Download
                              </span>
                            )
                          }
                        </PDFDownloadLink>
                      ) : (
                        <span
                          className="cursor-pointer"
                          onClick={() => handleDownloadClick(manifest.id)}
                        >
                          <MdDownload size={20} />
                        </span>
                      )}
                    </div>

                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        console.log('Viewing manifest details for ID:', manifest.id);
                        nextPage(manifest.id);
                      }}
                      title="View shipment details"
                    >
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="4" fill="#EBEBEB" />
                        <path d="M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z" fill="#3F83F8" />
                        <path d="M15.2536 9.30891C14.2289 8.60625 13.1323 8.25 11.9944 8.25C10.9704 8.25 9.97219 8.55469 9.02742 9.15187C8.07469 9.75539 7.1407 10.8516 6.375 12C6.99422 13.0312 7.84125 14.0916 8.72344 14.6995C9.73547 15.3966 10.8359 15.75 11.9944 15.75C13.1428 15.75 14.2409 15.3968 15.2592 14.7002C16.1557 14.0859 17.0088 13.027 17.625 12C17.0067 10.9821 16.1508 9.92437 15.2536 9.30891ZM12 14.25C11.555 14.25 11.12 14.118 10.75 13.8708C10.38 13.6236 10.0916 13.2722 9.92127 12.861C9.75097 12.4499 9.70642 11.9975 9.79323 11.561C9.88005 11.1246 10.0943 10.7237 10.409 10.409C10.7237 10.0943 11.1246 9.88005 11.561 9.79323C11.9975 9.70642 12.4499 9.75097 12.861 9.92127C13.2722 10.0916 13.6236 10.38 13.8708 10.75C14.118 11.12 14.25 11.555 14.25 12C14.2493 12.5965 14.012 13.1684 13.5902 13.5902C13.1684 14.012 12.5965 14.2493 12 14.25Z" fill="#3F83F8" />
                      </svg>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={13} className="text-center py-8 text-gray-500">
                  No manifests found. Try adjusting your filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View - Visible only on small/medium screens */}
      <div className="lg:hidden space-y-4">
        {userLists?.data?.length > 0 ? (
          userLists?.data?.map((manifest: any, index: number) => (
            <div
              key={manifest.id}
              className={`rounded-lg shadow-sm p-4 border-2 ${selectedManifests.includes(manifest.id)
                ? 'border-purple-400 bg-purple-50'
                : 'border-gray-200 bg-white'
                }`}
            >
              {/* Card Header with Checkbox */}
              <div className="flex justify-between items-start mb-3 pb-3 border-b border-gray-100">
                <div className="flex items-start gap-3 flex-1">
                  <input
                    type="checkbox"
                    checked={selectedManifests.includes(manifest.id)}
                    onChange={(e) => handleManifestSelection(manifest.id, e.target.checked)}
                    className="mt-1 w-5 h-5 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="bg-[#E04343] text-white text-xs font-bold px-2 py-1 rounded">
                        #{index + 1}
                      </span>
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        {manifest.shipment_status}
                      </span>
                    </div>
                    <h4 className="font-semibold text-[#030229] text-sm mb-1">
                      {manifest.manifest_name}
                    </h4>
                    <p className="text-xs text-gray-500">ID: {manifest.manifest_id}</p>
                  </div>
                </div>
                {/* Shipment count, not piece count — see the desktop table above. */}
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 ml-2">
                  {manifest.shipments_count ?? manifest.shipments?.length ?? 0} shipments
                </span>
              </div>

              {/* Branch Information */}
              <div className="grid grid-cols-2 gap-3 mb-3">
                <div className="bg-blue-50 p-2 rounded-lg">
                  <span className="text-xs text-gray-600 block mb-1">Origin Branch</span>
                  <span className="text-sm font-medium text-gray-900">{manifest.sender_branch}</span>
                </div>
                <div className="bg-purple-50 p-2 rounded-lg">
                  <span className="text-xs text-gray-600 block mb-1">Destination</span>
                  <span className="text-sm font-medium text-gray-900">{manifest.destination_branch}</span>
                </div>
              </div>

              {/* Manifest Details */}
              <div className="space-y-2 text-sm mb-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Date Created:</span>
                  <span className="font-medium text-gray-900">
                    {convertUTCDateToLocalDate(manifest.created_at)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Created By:</span>
                  <span className="font-medium text-gray-900">{manifest.created_by || 'N/A'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Fleet:</span>
                  <span className="font-medium text-gray-900">{manifest.fleet_name}</span>
                </div>
                {manifest.goods_description && (
                  <div className="pt-2 border-t border-gray-100">
                    <span className="text-gray-600 text-xs block mb-1">Description:</span>
                    <p className="text-gray-900 text-xs line-clamp-2">{manifest.goods_description}</p>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-2 pt-3 border-t border-gray-100">
                {userLoginData?.data?.role !== 'fleet' && userLoginData?.data?.role !== 'driver' && (
                  <button
                    onClick={() => { setRiderModal(true); setFleetData2(manifest) }}
                    className="flex-1 bg-blue-50 text-blue-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-blue-100 transition-colors"
                  >
                    Confirm
                  </button>
                )}

                <div className="flex-1">
                  {loadingDocId === manifest.id ? (
                    <PDFDownloadLink
                      document={<ShipmentManifest data={manifest} />}
                      fileName={`manifest_${manifest.manifest_id}.pdf`}
                    >
                      {({ loading }) => (
                        <button
                          className="w-full bg-green-50 text-green-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-green-100 transition-colors flex items-center justify-center gap-2"
                          disabled={loading}
                        >
                          <MdDownload size={18} />
                          {loading ? 'Loading...' : 'PDF'}
                        </button>
                      )}
                    </PDFDownloadLink>
                  ) : (
                    <button
                      onClick={() => handleDownloadClick(manifest.id)}
                      className="w-full bg-green-50 text-green-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-green-100 transition-colors flex items-center justify-center gap-2"
                    >
                      <MdDownload size={18} />
                      PDF
                    </button>
                  )}
                </div>

                <button
                  onClick={() => {
                    console.log('Viewing manifest details for ID:', manifest.id);
                    nextPage(manifest.id);
                  }}
                  className="flex-1 bg-gray-50 text-gray-600 text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-100 transition-colors flex items-center justify-center gap-2"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" fill="currentColor" />
                    <path fillRule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z" clipRule="evenodd" fill="currentColor" />
                  </svg>
                  View
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
            <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p className="text-gray-500 text-sm">No manifests found.</p>
            <p className="text-gray-400 text-xs mt-1">Try adjusting your filters.</p>
          </div>
        )}
      </div>
    </>
  );



  return (
    <>
      <AdminSidebar title="Manifests" />
      <div className="relative md:ml-64 bg-[#FAFAFA]">
        <AdminNavbar title="Enhanced Manifest Management" />

        {tabNo === "1" && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            {/* Enhanced Header */}
            <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 my-5'>
              <div>
                <h3 className='text-[18px] text-[#1C1C1C] font-semibold'>
                  Enhanced Manifest Management
                </h3>
                <p className='text-sm text-gray-600 mt-1'>
                  Manage and filter manifests with advanced search capabilities
                </p>
              </div>


              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                {/* Show multi-export button when manifests are selected */}
                {selectedManifests.length > 0 && (
                  <button
                    onClick={exportMultipleManifests}
                    disabled={isExportingMultiple}
                    className="bg-purple-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-purple-700 disabled:opacity-50 transition-colors flex items-center justify-center gap-2"
                  >
                    {isExportingMultiple ? (
                      <>
                        <Oval height="16" width="16" color="#ffffff" secondaryColor="#ffffff" />
                        <span>Exporting...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span>Export {selectedManifests.length} Selected</span>
                      </>
                    )}
                  </button>
                )}

                {/* NEW: Export All Filtered Button - exports all manifests with shipments */}
                {userLists?.total > 0 && (
                  <button
                    onClick={exportAllFilteredManifests}
                    disabled={isExportingAll}
                    className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50 transition-colors flex items-center justify-center gap-2"
                    title={`Export all ${userLists?.total} manifests with their shipments`}
                  >
                    {isExportingAll ? (
                      <>
                        <Oval height="16" width="16" color="#ffffff" secondaryColor="#ffffff" />
                        <span className="hidden sm:inline">Exporting All...</span>
                        <span className="sm:hidden">Exporting...</span>
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                        </svg>
                        <span className="hidden sm:inline">Export All Filtered ({userLists?.total})</span>
                        <span className="sm:hidden">All ({userLists?.total})</span>
                      </>
                    )}
                  </button>
                )}

                <button
                  onClick={handleExport}
                  disabled={loading}
                  className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 disabled:opacity-50 transition-colors"
                >
                  {loading ? 'Exporting...' : 'Export Current Page'}
                </button>

                <button
                  onClick={() => setAddModal(true)}
                  className="bg-[#E04343] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-red-600 transition-colors"
                >
                  Create Manifest
                </button>
              </div>



            </div>

            {/* Selection Info Banner */}
            {selectedManifests.length > 0 && (
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-4 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm font-medium text-purple-800">
                    {selectedManifests.length} manifest{selectedManifests.length > 1 ? 's' : ''} selected
                  </span>
                </div>
                <button
                  onClick={() => setSelectedManifests([])}
                  className="text-sm text-purple-600 hover:text-purple-800 font-medium"
                >
                  Clear Selection
                </button>
              </div>
            )}

            {/* Enhanced Filters - Show for admin/fleet/driver */}
            {userLoginData?.data?.role && (
              <ManifestFilters
                filters={filters}
                onFiltersChange={handleFiltersChange}
                onApplyFilters={handleApplyFilters}
                onClearFilters={handleClearFilters}
                stateOptions={stateFrom?.data || []}
              />
            )}

            {/* Office users - existing filter UI */}
            {!(userLoginData?.data?.role === 'admin' || userLoginData?.data?.role === 'fleet' || userLoginData?.data?.role === 'driver') && (
              <div className='md:flex justify-between mt-5'>
                <div className='flex md:justify-between justify-start gap-2'>
                  <button
                    onClick={() => {
                      console.log('Inbound button clicked');
                      const newFilters = { ...filters, type: 'inbound', page: 1 };
                      setFilters(newFilters);
                      fetchManifests(newFilters);
                    }}
                    type='button'
                    className={filters.type === 'inbound' ? 'bg-[#E04343] rounded-[12px] p-[4px] border-red-100 text-[12px] text-white' : 'bg-[#ffffff] border-red-500 border rounded-[12px] p-[4px] text-[12px] text-[#E04343]'}
                  >
                    In Bound
                  </button>
                  <button
                    onClick={() => {
                      console.log('Outbound button clicked');
                      const newFilters = { ...filters, type: 'outbound', page: 1 };
                      setFilters(newFilters);
                      fetchManifests(newFilters);
                    }}
                    type='button'
                    className={filters.type === 'outbound' ? 'bg-[#E04343] rounded-[12px] p-[4px] border-red-100 text-[12px] text-white' : 'bg-[#ffffff] border-red-500 border rounded-[12px] p-[4px] text-[12px] text-[#E04343]'}
                  >
                    Out Bound
                  </button>



                  {/* {userLoginData?.data?.role === 'admin' && */}
                  <button
                    onClick={() => {
                      console.log('All button clicked');
                      const newFilters = { ...filters, type: 'all', page: 1 };
                      setFilters(newFilters);
                      fetchManifests(newFilters);
                    }}
                    type='button'
                    className={filters.type === 'all' ? 'bg-[#E04343] rounded-[12px] p-[4px] border-red-100 text-[12px] text-white' : 'bg-[#ffffff] border-red-500 border rounded-[12px] p-[4px] text-[12px] text-[#E04343]'}
                  >
                    All
                  </button>
                  {/* } */}



                </div>
                {/* rest of your search section */}
              </div>
            )}

            {/* Statistics Cards */}
            <StatisticsCards manifestData={userLists} filters={filters} />

            {/* Rejected Numbers Display */}
            {rejectedNo?.length >= 1 && (
              <div className='flex justify-start mb-4'>
                <div className="bg-red-50 border border-red-200 rounded-md p-3">
                  <span className='text-red-800 text-sm font-medium'>
                    Rejected shipments: [{rejectedNo}]
                  </span>
                </div>
              </div>
            )}

            {/* Enhanced Table */}
            {screenLoader ? (
              <div className="flex justify-center items-center mt-[20vh]">
                <div className="text-center">
                  <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />
                  <p className="mt-4 text-gray-600">Loading manifests...</p>
                </div>
              </div>
            ) : (
              <ManifestTable />
            )}

            {/* Enhanced Pagination */}
            {/* Pagination - Mobile Responsive */}
            <div className='mt-6 flex justify-center'>
              <div className='flex flex-wrap justify-center gap-1 sm:gap-2 max-w-full px-2'>
                {userLists?.links?.map((link: any, index: number) => {
                  // Calculate which page numbers to show on mobile
                  const currentPage = userLists?.current_page;
                  const totalPages = userLists?.last_page;
                  const pageNumber = parseInt(link.label);

                  // On mobile, only show: Previous, first page, pages around current, last page, Next
                  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
                  const showOnMobile =
                    link.label === '&laquo; Previous' ||
                    link.label === 'Next &raquo;' ||
                    pageNumber === 1 ||
                    pageNumber === totalPages ||
                    (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1);

                  // Hide certain buttons on mobile
                  if (isMobile && !showOnMobile && !isNaN(pageNumber)) {
                    // Show ellipsis for skipped pages
                    if (
                      (pageNumber === 2 && currentPage > 3) ||
                      (pageNumber === totalPages - 1 && currentPage < totalPages - 2)
                    ) {
                      return (
                        <span
                          key={index}
                          className="px-2 py-1.5 sm:px-3 sm:py-2 text-xs sm:text-sm text-gray-400"
                        >
                          ...
                        </span>
                      );
                    }
                    return null;
                  }

                  return (
                    <button
                      key={index}
                      onClick={() => {
                        if (link.url) {
                          const page = link.label === 'Next &raquo;'
                            ? (userLists?.current_page + 1)
                            : link.label === '&laquo; Previous'
                              ? (userLists?.current_page - 1)
                              : parseInt(link.label);

                          paginator(page);
                        }
                      }}
                      disabled={!link.url}
                      className={`
            px-2 py-1.5 sm:px-3 sm:py-2 
            text-xs sm:text-sm 
            font-medium rounded-md 
            transition-colors
            min-w-[32px] sm:min-w-[40px]
            ${link.active
                          ? 'bg-[#E04343] text-white shadow-sm'
                          : link.url
                            ? 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 active:bg-gray-100'
                            : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        }
          `}
                    >
                      {/* Mobile: Short labels, Desktop: Full labels */}
                      <span className="hidden sm:inline">
                        {link.label === '&laquo; Previous' ? '← Previous' :
                          link.label === 'Next &raquo;' ? 'Next →' :
                            link.label}
                      </span>
                      <span className="sm:hidden">
                        {link.label === '&laquo; Previous' ? '←' :
                          link.label === 'Next &raquo;' ? '→' :
                            link.label}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* Shipment Details Tab */}
        {/* Shipment Details Tab - UPDATED */}
        {tabNo === "2" && (
          <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>
            <div className='flex flex-col gap-4 my-5'>
              {/* Title and stats section */}
              <div>
                <h3 className='text-[15px] md:text-[18px] text-[#1C1C1C] font-semibold capitalize'>
                  Shipments under {manifestData?.manifest_name || 'Unknown Manifest'}
                </h3>

                {/* Stats - responsive layout */}
                <div className='flex flex-wrap gap-x-3 gap-y-1 mt-2 text-xs sm:text-sm text-gray-600'>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Manifest ID:</span>
                    <span className='break-all'>{manifestData?.manifest_id}</span>
                  </span>
                  <span className='hidden sm:inline'>|</span>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Active:</span>
                    <span className='bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs'>
                      {manifestData?.shipment_counts?.active || 0}
                    </span>
                  </span>
                  <span className='hidden sm:inline'>|</span>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Moved:</span>
                    <span className='bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full text-xs'>
                      {manifestData?.shipment_counts?.moved || 0}
                    </span>
                  </span>
                  <span className='hidden sm:inline'>|</span>
                  <span className='flex items-center'>
                    <span className='font-semibold mr-1'>Total History:</span>
                    <span className='bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs'>
                      {manifestData?.shipment_counts?.total_history || 0}
                    </span>
                  </span>
                </div>
              </div>

              {/* Buttons section - responsive */}
              <div className='flex flex-col sm:flex-row gap-2'>
                <button
                  onClick={handleShipmentExport}
                  disabled={loading || !manifestData?.shipments?.length}
                  className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 disabled:opacity-50 transition-colors flex items-center justify-center gap-2 w-full sm:w-auto"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {/* Desktop: Full text, Mobile: Shorter text */}
                  <span className='hidden sm:inline'>
                    {loading ? 'Exporting...' : `Export ${manifestData?.shipments?.length || 0} Shipments`}
                  </span>
                  <span className='sm:hidden'>
                    {loading ? 'Exporting...' : `Export (${manifestData?.shipments?.length || 0})`}
                  </span>
                </button>

                <button
                  onClick={() => setTabNo('1')}
                  className="bg-gray-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-600 transition-colors w-full sm:w-auto flex items-center justify-center gap-2"
                >
                  ← Back to Manifests
                </button>
              </div>
            </div>

            {/* Statistics Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div className="bg-green-50 p-4 rounded-lg shadow-sm border border-green-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-green-600">
                      {manifestData?.shipment_counts?.active || 0}
                    </div>
                    <div className="text-sm text-green-800">Active Shipments</div>
                  </div>
                  <div className="text-green-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-yellow-600">
                      {manifestData?.shipment_counts?.moved || 0}
                    </div>
                    <div className="text-sm text-yellow-800">Moved Shipments</div>
                  </div>
                  <div className="text-yellow-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-200">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-2xl font-bold text-blue-600">
                      {manifestData?.shipment_counts?.total_history || 0}
                    </div>
                    <div className="text-sm text-blue-800">Total History</div>
                  </div>
                  <div className="text-blue-600">
                    <svg width="32" height="32" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Status Breakdown Section - Now Clickable for Filtering */}
            {manifestData?.shipments && manifestData.shipments.length > 0 && (() => {
              const activeShipments = manifestData.shipments.filter((s: any) => s.history_status === 'active');
              const statusCounts: { [key: string]: number } = {};

              activeShipments.forEach((shipment: any) => {
                const status = shipment?.Status || shipment?.status || 'Unknown';
                statusCounts[status] = (statusCounts[status] || 0) + 1;
              });

              const sortedStatuses = Object.entries(statusCounts).sort((a, b) => b[1] - a[1]);

              const getStatusColor = (status: string, isActive: boolean) => {
                const lowerStatus = status.toLowerCase();
                const baseColors = {
                  delivery: isActive ? 'bg-green-200 text-green-900 border-green-400 ring-2 ring-green-500' : 'bg-green-100 text-green-800 border-green-300',
                  transit: isActive ? 'bg-blue-200 text-blue-900 border-blue-400 ring-2 ring-blue-500' : 'bg-blue-100 text-blue-800 border-blue-300',
                  review: isActive ? 'bg-yellow-200 text-yellow-900 border-yellow-400 ring-2 ring-yellow-500' : 'bg-yellow-100 text-yellow-800 border-yellow-300',
                  failed: isActive ? 'bg-red-200 text-red-900 border-red-400 ring-2 ring-red-500' : 'bg-red-100 text-red-800 border-red-300',
                  arrived: isActive ? 'bg-purple-200 text-purple-900 border-purple-400 ring-2 ring-purple-500' : 'bg-purple-100 text-purple-800 border-purple-300',
                  default: isActive ? 'bg-gray-200 text-gray-900 border-gray-400 ring-2 ring-gray-500' : 'bg-gray-100 text-gray-800 border-gray-300',
                };

                if (lowerStatus.includes('delivery') || lowerStatus.includes('delivered')) return baseColors.delivery;
                if (lowerStatus.includes('transit') || lowerStatus.includes('out for')) return baseColors.transit;
                if (lowerStatus.includes('review') || lowerStatus.includes('pending')) return baseColors.review;
                if (lowerStatus.includes('failed') || lowerStatus.includes('unable')) return baseColors.failed;
                if (lowerStatus.includes('arrived') || lowerStatus.includes('hub')) return baseColors.arrived;
                return baseColors.default;
              };

              const handleStatusClick = (status: string) => {
                setActiveStatusFilter(activeStatusFilter === status ? null : status);
              };

              return sortedStatuses.length > 0 ? (
                <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3">
                    <h4 className="text-sm font-semibold text-gray-700 flex items-center">
                      <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
                      </svg>
                      Quick Filter by Status
                      <span className="ml-2 text-xs font-normal text-gray-500">(Click to filter)</span>
                    </h4>
                    {activeStatusFilter && (
                      <button
                        onClick={() => setActiveStatusFilter(null)}
                        className="text-xs text-red-600 hover:text-red-800 flex items-center gap-1 bg-red-50 px-2 py-1 rounded-full"
                      >
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                        Clear Filter
                      </button>
                    )}
                  </div>

                  {/* Desktop view */}
                  <div className="hidden sm:flex flex-wrap gap-2">
                    {sortedStatuses.map(([status, count]) => (
                      <button
                        key={status}
                        onClick={() => handleStatusClick(status)}
                        className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium border cursor-pointer transition-all hover:shadow-md ${getStatusColor(status, activeStatusFilter === status)}`}
                      >
                        {activeStatusFilter === status && (
                          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                        <span className="font-semibold">{status}</span>
                        <span className="ml-2 px-2 py-0.5 rounded-full bg-white bg-opacity-50 text-xs font-bold">{count}</span>
                      </button>
                    ))}
                  </div>

                  {/* Mobile view */}
                  <div className="sm:hidden overflow-x-auto">
                    <div className="flex gap-2 pb-2" style={{ minWidth: 'max-content' }}>
                      {sortedStatuses.map(([status, count]) => (
                        <button
                          key={status}
                          onClick={() => handleStatusClick(status)}
                          className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium border whitespace-nowrap cursor-pointer transition-all ${getStatusColor(status, activeStatusFilter === status)}`}
                        >
                          {activeStatusFilter === status && (
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          )}
                          <span className="font-semibold">{status}</span>
                          <span className="ml-2 px-2 py-0.5 rounded-full bg-white bg-opacity-50 text-xs font-bold">{count}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null;
            })()}

            {/* Search Box for Shipments */}
            <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 p-4">
              <div className="flex flex-col sm:flex-row gap-3">
                {/* Search Input */}
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Search Shipments
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                    <input
                      type="text"
                      value={shipmentSearchText}
                      onChange={(e) => setShipmentSearchText(e.target.value)}
                      placeholder="Search by name, phone, address, shipment number..."
                      className="block w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343] transition-colors"
                    />
                    {shipmentSearchText && (
                      <button
                        onClick={() => setShipmentSearchText('')}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                      >
                        <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>

                {/* Filter Summary */}
                <div className="flex items-end">
                  <div className="bg-gray-50 rounded-lg px-4 py-2.5 border border-gray-200">
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-gray-600">Showing:</span>
                      <span className="font-bold text-[#E04343]">{filteredShipments.length}</span>
                      <span className="text-gray-600">of</span>
                      <span className="font-bold text-gray-800">{manifestData?.shipments?.length || 0}</span>
                      <span className="text-gray-600">shipments</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Active Filters Display */}
              {(shipmentSearchText || activeStatusFilter) && (
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="text-xs text-gray-500">Active filters:</span>

                  {activeStatusFilter && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">
                      Status: {activeStatusFilter}
                      <button onClick={() => setActiveStatusFilter(null)} className="hover:text-blue-600">
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </span>
                  )}

                  {shipmentSearchText && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                      Search: "{shipmentSearchText}"
                      <button onClick={() => setShipmentSearchText('')} className="hover:text-purple-600">
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </span>
                  )}

                  <button
                    onClick={() => {
                      setShipmentSearchText('');
                      setActiveStatusFilter(null);
                    }}
                    className="text-xs text-red-600 hover:text-red-800 underline ml-2"
                  >
                    Clear all filters
                  </button>
                </div>
              )}
            </div>

            {screenLoader ? (
              <div className="flex justify-center items-center mt-[20vh]">
                <div className="text-center">
                  <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />
                  <p className="mt-4 text-gray-600">Loading shipment details...</p>
                </div>
              </div>
            ) : (
              <>
                {/* Desktop Table View - Hidden on mobile */}
                <div className="hidden lg:block relative overflow-x-auto bg-white rounded-lg shadow-sm">
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                    <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                      <tr>
                        <th scope="col" className="px-2 py-2">S/N</th>
                        <th scope="col" className="px-2 py-2">Status Badge</th>
                        <th scope="col" className="px-2 py-2">Receiver Name</th>
                        <th scope="col" className="px-2 py-2">Receiver Phone</th>
                        <th scope="col" className="px-2 py-2">Receiver Address</th>
                        <th scope="col" className="px-2 py-2">Shipment Status</th>
                        <th scope="col" className="px-2 py-2">Shipment Number</th>
                        <th scope="col" className="px-2 py-2">Event Date/Time</th>
                        <th scope="col" className="px-2 py-2">Date Source</th>
                        <th scope="col" className="px-2 py-2">Deadline</th>
                        <th scope="col" className="px-2 py-2">Weight</th>
                        <th scope="col" className="px-2 py-2">Items</th>
                        <th scope="col" className="px-2 py-2">Upload</th>
                        <th scope="col" className="px-2 py-2">Moved Info</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredShipments?.length > 0 ? (
                        filteredShipments.map((shipment: any, index: number) => (
                          <tr
                            key={shipment.id || index}
                            className={`${shipment.history_status === 'moved'
                              ? 'bg-yellow-50 border-l-4 border-yellow-400'
                              : 'bg-white'
                              }`}
                          >
                            <td className="px-2 py-2">{index + 1}</td>

                            <td className="px-2 py-2">
                              {shipment.history_status === 'active' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                  </svg>
                                  Moved
                                </span>
                              )}
                            </td>

                            <td className="px-6 py-4">{shipment?.ReceiverName || shipment?.receiver_name || 'N/A'}</td>
                            <td className="px-6 py-4">{shipment?.ReceiverPhone || shipment?.receiver_phone || 'N/A'}</td>
                            <td className="px-6 py-4">{shipment?.ReceiverAdd1 || shipment?.receiver_address || 'N/A'}</td>

                            <td className="px-2 py-2 cursor-pointer" onClick={() => { toggleStatus(); setShipmentId(shipment); setDelieveryInstruction(shipment?.DeliveryInstructions || '') }}>
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${shipment?.Status === 'inReview' || shipment?.Status === 'InReview' || shipment?.status === 'inReview'
                                ? 'bg-yellow-100 text-yellow-800'
                                : shipment?.Status === 'delivered' || shipment?.status === 'delivered'
                                  ? 'bg-green-100 text-green-800'
                                  : shipment?.Status === 'in_transit' || shipment?.status === 'in_transit'
                                    ? 'bg-blue-100 text-blue-800'
                                    : 'bg-gray-100 text-gray-800'
                                }`}>
                                {shipment?.Status || shipment?.status || 'Unknown'}
                              </span>
                            </td>

                            <td className="px-6 py-4">{shipment?.ShipmentNumber || shipment?.shipment_number || 'Not Available'}</td>
                            <td className="px-6 py-4">
                              <div className="text-sm">
                                {shipment?.event_datetime
                                  ? formatDateTimeDisplay(shipment.event_datetime)
                                  : formatDateTimeDisplay(shipment?.updated_at)
                                }
                              </div>
                            </td>

                            {/* Manual Date Badge Column */}
                            <td className="px-6 py-4">
                              {shipment?.is_date_manually_set ? (
                                <div className="flex flex-col items-start">
                                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800 border border-orange-200">
                                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                    </svg>
                                    Manual
                                  </span>
                                  {shipment?.date_set_by && (
                                    <span className="text-xs text-gray-500 mt-1">
                                      by: {shipment.date_set_by}
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  Auto
                                </span>
                              )}
                            </td>

                            <td className="px-2 py-2">
                              {(() => {
                                const deadlineInfo = getDeadlineStatus(shipment?.dead_line);
                                return (
                                  <div className="flex flex-col items-start">
                                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${deadlineInfo.bgColor} ${deadlineInfo.textColor} ${deadlineInfo.borderColor}`}>
                                      {deadlineInfo.status === 'expired' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'critical' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'warning' && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.status === 'safe' && shipment?.dead_line && (
                                        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                      )}
                                      {deadlineInfo.text}
                                    </span>
                                    {shipment?.dead_line && deadlineInfo.status !== 'expired' && (
                                      <span className="text-xs text-gray-500 mt-1">
                                        {new Date(shipment.dead_line).toLocaleDateString('en-US', {
                                          month: 'short',
                                          day: 'numeric',
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}
                                      </span>
                                    )}
                                  </div>
                                );
                              })()}
                            </td>
                            <td className="px-6 py-4">{shipment?.Weight || shipment?.weight || '0'} kg</td>
                            <td className="px-6 py-4">{shipment?.NoOfItems || shipment?.number_of_items || '0'}</td>

                            {(shipment?.del_doc !== null && shipment?.del_doc !== 'No selected file') ?
                              <td className="px-6 py-4">
                                <a href={shipment?.del_doc} target="_blank" rel="noopener noreferrer" className='underline text-blue-500'>View</a>
                              </td>
                              :
                              <td className="px-6 py-4">{shipment?.Status == 'Proof of Delivery' ? shipment?.delievery_code : '--'}</td>
                            }

                            <td className="px-6 py-4">
                              {shipment.history_status === 'moved' ? (
                                <div className="text-xs">
                                  <div className="font-semibold text-yellow-800 mb-1">Moved to:</div>
                                  <div className="text-yellow-700 mb-1">{shipment.moved_to_manifest_name || 'Unknown Manifest'}</div>
                                  <div className="text-gray-500">ID: {shipment.moved_to_manifest_id || 'N/A'}</div>
                                  {shipment.moved_at && (
                                    <div className="text-gray-500 mt-1">
                                      {new Date(shipment.moved_at).toLocaleDateString()}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <span className="text-gray-400 text-xs">Currently active</span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center py-8">
                            {manifestData?.shipments?.length > 0 ? (
                              <div className="text-gray-500">
                                <svg className="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <p className="font-medium">No shipments match your search</p>
                                <p className="text-sm mt-1">
                                  Try adjusting your search terms or
                                  <button
                                    onClick={() => {
                                      setShipmentSearchText('');
                                      setActiveStatusFilter(null);
                                    }}
                                    className="text-[#E04343] hover:underline ml-1"
                                  >
                                    clear all filters
                                  </button>
                                </p>
                              </div>
                            ) : (
                              <p className="text-gray-500">
                                {manifestData ? 'No shipments found for this manifest.' : 'Loading manifest details...'}
                              </p>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View - Visible only on small/medium screens */}
                <div className="lg:hidden space-y-4">
                  {filteredShipments?.length > 0 ? (
                    filteredShipments?.map((shipment: any, index: number) => (
                      <div
                        key={shipment.id || index}
                        className={`rounded-lg shadow-sm p-4 border-2 ${shipment.history_status === 'moved'
                          ? 'bg-yellow-50 border-yellow-400'
                          : 'bg-white border-gray-200'
                          }`}
                      >
                        {/* Card Header */}
                        <div className="flex justify-between items-start mb-3 pb-3 border-b border-gray-200">
                          <div>
                            <div className="flex items-center gap-2 mb-2">
                              <span className="bg-[#E04343] text-white text-xs font-bold px-2 py-1 rounded">
                                #{index + 1}
                              </span>
                              {shipment.history_status === 'active' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                  </svg>
                                  Active
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-200">
                                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                  </svg>
                                  Moved
                                </span>
                              )}
                            </div>
                            <h4 className="font-semibold text-gray-900 text-sm">
                              {shipment?.ShipmentNumber || shipment?.shipment_number || 'Not Available'}
                            </h4>
                          </div>

                          {/* Shipment Status Badge */}
                          <span onClick={() => { toggleStatus(); setShipmentId(shipment); setDelieveryInstruction(shipment?.DeliveryInstructions || '') }} className={`inline-flex items-center cursor-pointer px-2 py-1 rounded-full text-xs font-medium ${shipment?.Status === 'inReview' || shipment?.Status === 'InReview' || shipment?.status === 'inReview'
                            ? 'bg-yellow-100 text-yellow-800'
                            : shipment?.Status === 'delivered' || shipment?.status === 'delivered'
                              ? 'bg-green-100 text-green-800'
                              : shipment?.Status === 'in_transit' || shipment?.status === 'in_transit'
                                ? 'bg-blue-100 text-blue-800'
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                            {shipment?.Status || shipment?.status || 'Unknown'}
                          </span>
                        </div>

                        {/* Receiver Information */}
                        <div className="space-y-2 mb-3">
                          <div className="bg-blue-50 p-3 rounded-lg">
                            <h5 className="text-xs font-semibold text-gray-700 mb-2 uppercase">Receiver Details</h5>
                            <div className="space-y-1.5 text-sm">
                              <div className="flex justify-between">
                                <span className="text-gray-600">Name:</span>
                                <span className="font-medium text-gray-900 text-right">
                                  {shipment?.ReceiverName || shipment?.receiver_name || 'N/A'}
                                </span>
                              </div>

                              <div className="flex justify-between">
                                <span className="text-gray-600">Event Date:</span>
                                <div className="flex items-center gap-2">
                                  <span className="font-medium text-gray-900 text-sm">
                                    {shipment?.event_datetime
                                      ? formatDateTimeDisplay(shipment.event_datetime)
                                      : formatDateTimeDisplay(shipment?.updated_at)
                                    }
                                  </span>
                                  {shipment?.is_date_manually_set && (
                                    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-800">
                                      Manual
                                    </span>
                                  )}
                                </div>
                              </div>

                              {shipment?.is_date_manually_set && shipment?.date_set_by && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">Set By:</span>
                                  <span className="font-medium text-gray-900 text-xs">
                                    {shipment.date_set_by}
                                  </span>
                                </div>
                              )}
                              <div className="flex justify-between">
                                <span className="text-gray-600">Phone:</span>
                                <a
                                  href={`tel:${shipment?.ReceiverPhone || shipment?.receiver_phone}`}
                                  className="font-medium text-blue-600 hover:underline"
                                >
                                  {shipment?.ReceiverPhone || shipment?.receiver_phone || 'N/A'}
                                </a>
                              </div>
                              <div className="flex flex-col">
                                <span className="text-gray-600 mb-1">Address:</span>
                                <span className="font-medium text-gray-900 text-sm">
                                  {shipment?.ReceiverAdd1 || shipment?.receiver_address || 'N/A'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Shipment Details Grid */}
                        <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                          <div className="bg-purple-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Weight</span>
                            <span className="font-medium text-gray-900 text-xs">
                              {shipment?.Weight || shipment?.weight || '0'} kg
                            </span>
                          </div>
                          <div className="bg-purple-50 p-2 rounded">
                            <span className="text-gray-600 text-xs block">Items</span>
                            <span className="font-medium text-gray-900 text-xs">
                              {shipment?.NoOfItems || shipment?.number_of_items || '0'} pcs
                            </span>
                          </div>
                        </div>

                        {/* Deadline Section */}
                        <div className="mb-3">
                          {(() => {
                            const deadlineInfo = getDeadlineStatus(shipment?.dead_line);
                            return (
                              <div className={`p-3 rounded-lg border ${deadlineInfo.bgColor} ${deadlineInfo.borderColor}`}>
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    {deadlineInfo.status === 'expired' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'critical' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'warning' && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {deadlineInfo.status === 'safe' && shipment?.dead_line && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    {!shipment?.dead_line && (
                                      <svg className={`w-5 h-5 ${deadlineInfo.textColor}`} fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                      </svg>
                                    )}
                                    <div>
                                      <span className={`text-xs font-semibold ${deadlineInfo.textColor}`}>Deadline</span>
                                      <p className={`text-sm font-bold ${deadlineInfo.textColor}`}>{deadlineInfo.text}</p>
                                    </div>
                                  </div>
                                  {shipment?.dead_line && (
                                    <div className="text-right">
                                      <span className={`text-xs ${deadlineInfo.textColor}`}>
                                        {new Date(shipment.dead_line).toLocaleDateString('en-US', {
                                          month: 'short',
                                          day: 'numeric',
                                        })}
                                      </span>
                                      <p className={`text-xs ${deadlineInfo.textColor}`}>
                                        {new Date(shipment.dead_line).toLocaleTimeString('en-US', {
                                          hour: '2-digit',
                                          minute: '2-digit',
                                        })}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })()}
                        </div>

                        {/* Moved Info Section */}
                        {shipment.history_status === 'moved' && (
                          <div className="bg-yellow-100 border border-yellow-300 rounded-lg p-3 mt-3">
                            <div className="flex items-start gap-2">
                              <svg className="w-5 h-5 text-yellow-700 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                              <div className="flex-1">
                                <p className="text-xs font-semibold text-yellow-800 mb-1">Moved to:</p>
                                <p className="text-xs text-yellow-700 font-medium">
                                  {shipment.moved_to_manifest_name || 'Unknown Manifest'}
                                </p>
                                <p className="text-xs text-gray-600 mt-1">
                                  ID: {shipment.moved_to_manifest_id || 'N/A'}
                                </p>
                                {shipment.moved_at && (
                                  <p className="text-xs text-gray-600 mt-1">
                                    Date: {new Date(shipment.moved_at).toLocaleDateString()}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Active Status Indicator */}
                        {shipment.history_status === 'active' && (
                          <div className="bg-green-50 border border-green-200 rounded-lg p-2 mt-3">
                            <p className="text-xs text-green-700 text-center font-medium">
                              ✓ Currently Active in Manifest
                            </p>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                      <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                      </svg>
                      <p className="text-gray-500 text-sm">


                        {filteredShipments?.length === 0 && (
                          <tr>
                            <td colSpan={14} className="text-center py-8">
                              {manifestData?.shipments?.length > 0 ? (
                                <div className="text-gray-500">
                                  <svg className="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                  </svg>
                                  <p className="font-medium">No shipments match your search</p>
                                  <p className="text-sm mt-1">
                                    Try adjusting your search terms or
                                    <button
                                      onClick={() => {
                                        setShipmentSearchText('');
                                        setActiveStatusFilter(null);
                                      }}
                                      className="text-[#E04343] hover:underline ml-1"
                                    >
                                      clear all filters
                                    </button>
                                  </p>
                                </div>
                              ) : (
                                <p className="text-gray-500">No shipments found for this manifest.</p>
                              )}
                            </td>
                          </tr>
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}


            {/* Enhanced Manifest Summary */}
            {manifestData && (
              <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                <h4 className="text-lg font-semibold mb-3">Manifest Summary</h4>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  <div>
                    <span className="text-gray-600 text-sm">Total Weight:</span>
                    <p className="font-medium">{manifestData?.weight || '0'} kg</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Total Pieces:</span>
                    <p className="font-medium">{manifestData?.pcs || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Active Shipments:</span>
                    <p className="font-medium text-green-600">{manifestData?.shipment_counts?.active || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Moved Shipments:</span>
                    <p className="font-medium text-yellow-600">{manifestData?.shipment_counts?.moved || '0'}</p>
                  </div>
                  <div>
                    <span className="text-gray-600 text-sm">Fleet:</span>
                    <p className="font-medium">{manifestData?.fleet_name || 'N/A'}</p>
                  </div>
                </div>
              </div>
            )}
          </div>



        )}


      </div>

      {/* Keep your existing modals */}
      <section>
        <Modal
          visible={addModal}
          width="900"
          height="700"
          effect="fadeInUp"
          onClickAway={() => setAddModal(false)}
        >
          {loading ? (
            <div className="flex flex-col mt-[30vh] mx-5">
              <div className="w-full bg-gray-200 rounded-full">
                <div className="bg-[#E04343] text-xs font-medium text-white text-center p-0.5 leading-none rounded-full" style={{ width: `${percentage}%` }}>
                  {percentage}%
                </div>
              </div>
              <div className='flex justify-center mt-4'>
                <Oval
                  visible={true}
                  height="60"
                  width="60"
                  color="#E04343"
                  secondaryColor="#FCBF94"
                  ariaLabel="oval-loading"
                />
              </div>
              <div className='flex justify-center mt-3'>
                <span>Creating manifest, please wait...</span>
              </div>
            </div>
          ) : (
            <div className="" style={{ height: '100%', overflow: 'auto' }}>
              <div className="container bg-[#fff] rounded-lg p-2">
                <div className="px-3">
                  <span className="flex justify-between px-2 pt-3">
                    <p className='mt-2 text-lg font-semibold'>Create New Manifest</p>
                    <p className="cursor-pointer font-bold" onClick={(e) => setAddModal(false)}>
                      <SvgElement type={icontypesEnum.CANCEL} />
                    </p>
                  </span>

                  <form onSubmit={handleSubmit}>
                    <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                      <div className="relative flex flex-col min-w-0 break-words w-full">
                        <div className="flex-auto py-5 pt-0">
                          <div className="flex flex-wrap">
                            {/* Manifest Details Section */}
                            <div className="lg:w-4/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Manifest Name</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  required
                                  type="text"
                                  name='manifest_name'
                                  value={userData?.manifest_name}
                                  onChange={handleChange}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="Enter manifest name"
                                />
                              </div>
                            </div>

                            <div className="lg:w-8/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Notes</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <textarea
                                  name='goods_description'
                                  value={userData?.goods_description}
                                  onChange={(e: any) => handleChange(e)}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="Enter description"
                                />
                              </div>
                            </div>

                            {/* Airwaybill Number Field - CREATIVE INTEGRATED MANAGEMENT */}
                            <div className="w-full lg:pr-4 mb-4">
                              <div className="flex justify-between items-center mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">
                                  Airwaybill Number <span className="text-red-500">*</span>
                                </label>
                                <button
                                  type="button"
                                  onClick={() => setShowAirwaybillDrawer(true)}
                                  className="text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  </svg>
                                  Manage All
                                </button>
                              </div>

                              <div className="relative">
                                {/* Main Select/Search Dropdown */}
                                <select
                                  required
                                  value={selectedAirwaybillNumber?.id || ''}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === 'create_new') {
                                      setShowAirwaybillCreateModal(true);
                                    } else if (value) {
                                      const selected = airwaybillNumbers.find((aw: any) => aw.id == value);
                                      setSelectedAirwaybillNumber(selected);
                                      setUserdata({ ...userData, airwaybill_number_id: value });
                                    } else {
                                      setSelectedAirwaybillNumber(null);
                                      setUserdata({ ...userData, airwaybill_number_id: null });
                                    }
                                  }}
                                  className={`border text-gray-900 text-sm rounded-[5px] block w-full p-2.5 pr-10 appearance-none bg-white ${!selectedAirwaybillNumber ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-[#D1D1D1]'
                                    }`}
                                  disabled={airwaybillLoading}
                                >
                                  <option value="">-- Select Airwaybill Number --</option>

                                  {/* Create New Option */}
                                  <option
                                    value="create_new"
                                    className="font-semibold text-blue-600 bg-blue-50"
                                  >
                                    ➕ Create New Airwaybill Number
                                  </option>

                                  {/* Separator */}
                                  <option disabled>──────────────────</option>

                                  {/* Existing Airwaybill Numbers */}
                                  {airwaybillNumbers.length > 0 ? (
                                    airwaybillNumbers.map((aw: any) => (
                                      <option key={aw.id} value={aw.id}>
                                        {aw.airwaybill_number} {aw.description ? `- ${aw.description}` : ''}
                                      </option>
                                    ))
                                  ) : (
                                    <option disabled>No airwaybill numbers available</option>
                                  )}
                                </select>

                                {/* Loading Indicator */}
                                {airwaybillLoading && (
                                  <div className="absolute right-3 top-3">
                                    <Oval height="20" width="20" color="#E04343" secondaryColor="#FCBF94" />
                                  </div>
                                )}

                                {/* Selected Info Badge */}
                                {selectedAirwaybillNumber && (
                                  <div className="mt-2 flex items-center gap-2">
                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                                      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                      </svg>
                                      {selectedAirwaybillNumber.airwaybill_number} Selected
                                    </span>
                                    {selectedAirwaybillNumber.description && (
                                      <span className="text-xs text-gray-500">
                                        {selectedAirwaybillNumber.description}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>

                              <p className={`text-xs mt-1 ${!selectedAirwaybillNumber ? 'text-red-500 font-medium' : 'text-gray-500'}`}>
                                {!selectedAirwaybillNumber
                                  ? '⚠️ Airwaybill number is required. Please select or create one before proceeding.'
                                  : 'Select an existing airwaybill number or create a new one'
                                }
                              </p>
                            </div>

                            {/* Form Fields Row */}
                            <div className="lg:w-4/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Origin Branch</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  value={userLoginData?.data?.branch || 'Not Available'}
                                  readOnly
                                  className="border border-[#D1D1D1] bg-gray-100 text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5 cursor-not-allowed"
                                  placeholder="Origin branch (auto-filled)"
                                />
                              </div>
                            </div>



                            {/* Destination State Dropdown */}
                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Destination State
                                </label>
                                <select
                                  required
                                  value={selectedDestinationState}
                                  onChange={handleDestinationStateChange}
                                  className="border border-[#D1D1D1] bg-white text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value="">--Select Destination State--</option>
                                  {destinationStates?.map((state: any, index: any) => (
                                    <option key={index} value={state}>{state}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            {/* Destination Branch Dropdown */}
                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Destination Branch
                                </label>
                                <select
                                  required
                                  value={userData.destination_state}
                                  onChange={handleDestinationBranchChange}
                                  disabled={!selectedDestinationState}
                                  className="border border-[#D1D1D1] bg-white text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150 disabled:opacity-50"
                                >
                                  <option value="">--Select Destination Branch--</option>
                                  {destinationBranches?.map((branch: any, index: any) => (
                                    <option key={index} value={branch.branch_name}>{branch.branch_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Status
                                </label>
                                <select
                                  required
                                  name='shipment_status'
                                  onChange={handleChange}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option disabled selected>--Select Status--</option>
                                  <option value="In Transit to Destination">In Transit to Destination</option>
                                  <option value="PreSort to Area">PreSort to Area</option>
                                  <option value="In Transit - Remote Location">In Transit - Remote Location</option>
                                  <option value="Information">Information</option>


                                  {/* {STATUSTYPES?.map((status: any, index: any) => (
                                    <option key={index} value={status?.EventName}>{status?.EventName}</option>
                                  ))} */}
                                </select>
                              </div>
                            </div>

                            {/* Manifest Type — TEMPORARILY HIDDEN (2026-07-15). Change false→true to restore. */}
                            {false && (
                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Manifest Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                  required
                                  value={manifestType}
                                  onChange={(e) => setManifestType(e.target.value)}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value="fleet">Fleet Manifest</option>
                                  <option value="individual">Individual Rider Manifest</option>
                                </select>
                                <p className="text-xs text-gray-500 mt-1">
                                  {manifestType === 'fleet'
                                    ? 'Only fleet riders can create OFD for shipments in this manifest.'
                                    : 'Only independent riders can create OFD for shipments in this manifest.'}
                                </p>
                              </div>
                            </div>
                            )}

                            {/* Audit-only manifest */}
                            <div className="w-full lg:w-12/12 lg:pr-4">
                              <div className={`relative w-full mb-5 rounded-lg border p-3 ${isAuditOnly ? 'border-amber-400 bg-amber-50' : 'border-gray-200 bg-gray-50'}`}>
                                <label className="flex items-start gap-3 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={isAuditOnly}
                                    onChange={(e) => setIsAuditOnly(e.target.checked)}
                                    className="mt-0.5 w-4 h-4 accent-[#E04343] cursor-pointer"
                                  />
                                  <span>
                                    <span className="block text-sm font-semibold text-[#19213D]">
                                      Audit only — do not change shipment statuses
                                    </span>
                                    <span className="block text-xs text-gray-600 mt-1">
                                      Use this to re-file shipments that were put on the wrong manifest and have
                                      already been delivered. The shipments move onto this manifest, but their
                                      status, event date and deadline are left exactly as they are, and nothing is
                                      sent to the partner or the customer.
                                    </span>
                                  </span>
                                </label>
                                {isAuditOnly && (
                                  <p className="text-xs text-amber-800 font-medium mt-2 ml-7">
                                    The status selected above will be recorded on the manifest, but will not be
                                    applied to any shipment.
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Fleet
                                </label>
                                <Select
                                  options={(fleetData || []).map((fleet: any) => ({ value: fleet?.id, label: fleet?.first_name }))}
                                  value={
                                    shipmentRider?.target?.value
                                      ? (fleetData || [])
                                          .filter((fleet: any) => String(fleet?.id) === String(shipmentRider.target.value))
                                          .map((fleet: any) => ({ value: fleet?.id, label: fleet?.first_name }))[0] || null
                                      : null
                                  }
                                  onChange={(option: any) => {
                                    const value = option?.value ?? '';
                                    setShipmentRider({ target: { value } });
                                    getAllVehicles(value);
                                    if (option) {
                                      const selectedFleet = (fleetData || []).find((fleet: any) => fleet?.id == option.value);
                                      if (selectedFleet) {
                                        setUserdata({
                                          ...userData,
                                          manifest_name: `${selectedFleet.first_name} - ${getCurrentDateTime()}`,
                                          goods_description: `To be delivered by ${selectedFleet?.first_name}`
                                        });
                                      }
                                    }
                                  }}
                                  isSearchable
                                  isClearable
                                  placeholder="Search and select fleet..."
                                  noOptionsMessage={() => 'No matching fleet found'}
                                  classNamePrefix="select"
                                />
                              </div>
                            </div>

                            <div className="w-full lg:w-4/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Vehicle
                                </label>
                                <select
                                  required
                                  name='vehicle_name'
                                  onChange={handleChange}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option selected>Select Vehicle</option>
                                  {vehicle?.filter((veh: any) => veh?.status === 'Available')?.map((veh: any, index: any) => (
                                    <option key={index} value={veh?.vehicle_name}>{veh?.vehicle_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="lg:w-4/12 w-full lg:pr-4 ">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Fleet Price</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="number"
                                  name='fleet_price'
                                  onChange={handleChange}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="0.00"
                                />
                              </div>
                            </div>


                            <div className="lg:w-4/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">
                                  Event Date/Time
                                </label>
                                <span className="text-xs text-gray-500">(Optional)</span>
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="datetime-local"
                                  value={eventDateTime}
                                  max={(() => {
                                    const now = new Date();
                                    const offset = now.getTimezoneOffset();
                                    return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                                  })()}
                                  onChange={(e) => {
                                    const now = new Date();
                                    const offset = now.getTimezoneOffset();
                                    const localNow = new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                                    if (e.target.value <= localNow) {
                                      setEventDateTime(e.target.value);
                                    }
                                  }}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full p-2.5"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                  Only current or past date/time allowed.
                                </p>
                              </div>
                            </div>




                            <div className="lg:w-4/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">
                                  Delivery Deadline <span className="text-red-500">*</span>
                                </label>
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="datetime-local"
                                  required
                                  value={deadLine}
                                  onChange={(e) => setDeadLine(e.target.value)}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full p-2.5"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                  Set the deadline by which all shipments in this manifest should be delivered.
                                </p>
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Custom Value</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  name='custom_value'
                                  onChange={handleChange}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="Enter custom value"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Shipment Selection Toggle */}
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => setShowShipment(!showShipment)}
                        className="text-red-700 bg-red-200 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-2 py-1.5 text-center"
                      >
                        {showShipment ? "Hide" : 'Show'} Available Shipments
                      </button>
                    </div>

                    {/* Available Shipments Table */}
                    <div className={showShipment ? "h-[250px] overflow-auto mb-4" : 'hidden'}>
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                        <thead className="text-[12px] text-[#808080] bg-[#FAFAFA]">
                          <tr>
                            <th scope="col" className="px-2 py-2">Select</th>
                            <th scope="col" className="px-2 py-2">Receiver Name</th>
                            <th scope="col" className="px-2 py-2">Receiver Phone</th>
                            <th scope="col" className="px-2 py-2">Receiver Address</th>
                            <th scope="col" className="px-2 py-2">Status</th>
                            <th scope="col" className="px-2 py-2">Shipment Number</th>
                            <th scope="col" className="px-2 py-2">Fleet</th>
                            <th scope="col" className="px-2 py-2">Vehicle</th>
                          </tr>
                        </thead>
                        <tbody>
                          {manifestListData?.filter((e: any) => (e?.ShipmentNumber))?.map((shipment: any, index: any) => (
                            <tr key={index} className="bg-white">
                              <td className="px-6 py-4 font-medium text-[#6C757D] whitespace-nowrap">
                                <div className="flex space-x-3">
                                  <div className="flex items-center">
                                    <input
                                      id="default-checkbox"
                                      type="checkbox"
                                      value={shipment?.ShipmentNumber}
                                      onChange={(e) => selectShipment(e, shipment)}
                                      className="w-4 h-4 accent-[#E04343] bg-gray-100 border-gray-300 rounded focus:ring-[#E04343] cursor-pointer"
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4">{shipment?.ReceiverName}</td>
                              <td className="px-6 py-4">{shipment?.ReceiverPhone}</td>
                              <td className="px-6 py-4">{shipment?.ReceiverAdd1}</td>
                              <td className="px-2 py-2">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${shipment?.Status === 'inReview' || shipment?.Status === 'InReview'
                                  ? 'bg-yellow-100 text-yellow-800'
                                  : 'bg-green-100 text-green-800'
                                  }`}>
                                  {shipment?.Status}
                                </span>
                              </td>
                              <td className="px-6 py-4">{shipment?.ShipmentNumber || 'Not Available'}</td>
                              <td className="px-6 py-4">{shipment?.fleet_name || "No Fleet"}</td>
                              <td className="px-6 py-4">{shipment?.vehicle_name || "No Vehicle"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>


                    {/* Geofence Warning Banner */}
                    {geofenceMismatches.length > 0 && selectedDestinationState && (
                      <div className="bg-orange-50 border border-orange-300 rounded-lg p-4 mb-4">
                        <div className="flex items-start gap-3">
                          <svg className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <div className="flex-1">
                            <h4 className="font-semibold text-orange-800 text-sm mb-1">
                              Geofence Warning — {geofenceMismatches.length} shipment(s) don't match destination state
                            </h4>
                            <p className="text-xs text-orange-700 mb-2">
                              The following shipments have a receiver state that differs from the selected destination state (<strong>{selectedDestinationState}</strong>). They will still be added but may be delivered to the wrong area.
                            </p>
                            <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto">
                              {geofenceMismatches.map((num) => (
                                <span key={num} className="inline-flex items-center gap-1 px-2 py-1 bg-orange-100 text-orange-800 rounded text-xs font-mono border border-orange-200">
                                  {num}
                                  <span className="text-orange-500">→ {shipmentStates[num] || 'Unknown'}</span>
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="p-4 border rounded-lg bg-white">
                      <div className="flex justify-between items-center mb-4">
                        <h1 className="text-xl font-bold">Enhanced Barcode Scanner</h1>
                        {isValidating && (
                          <div className="flex items-center text-blue-600">
                            <Oval height="20" width="20" color="#3B82F6" secondaryColor="#93C5FD" />
                            <span className="ml-2 text-sm">Validating...</span>
                          </div>
                        )}
                      </div>

                      {/* Statistics Panel */}
                      <div className={`grid ${geofenceMismatches.length > 0 ? 'grid-cols-5' : 'grid-cols-4'} gap-4 mb-4`}>
                        <div className="bg-blue-50 p-3 rounded-lg text-center">
                          <div className="text-2xl font-bold text-blue-600">{scannerStats.total}</div>
                          <div className="text-sm text-blue-800">Total Scanned</div>
                        </div>
                        <div className="bg-green-50 p-3 rounded-lg text-center">
                          <div className="text-2xl font-bold text-green-600">{scannerStats.valid}</div>
                          <div className="text-sm text-green-800">Valid</div>
                        </div>
                        <div className="bg-red-50 p-3 rounded-lg text-center">
                          <div className="text-2xl font-bold text-red-600">{scannerStats.invalid}</div>
                          <div className="text-sm text-red-800">Invalid</div>
                        </div>
                        <div className="bg-yellow-50 p-3 rounded-lg text-center">
                          <div className="text-2xl font-bold text-yellow-600">{scannerStats.duplicates}</div>
                          <div className="text-sm text-yellow-800">Duplicates</div>
                        </div>


                        {geofenceMismatches.length > 0 && (
                          <div className="bg-orange-50 p-3 rounded-lg text-center">
                            <div className="text-2xl font-bold text-orange-600">{geofenceMismatches.length}</div>
                            <div className="text-sm text-orange-800">State Mismatch</div>
                          </div>
                        )}
                      </div>

                      {/* Barcode Input */}
                      {/* Barcode Input */}
                      <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                          Scan New Barcode: {barcodeValues.length} scanned
                        </label>

                        {/* Wrap input in a form for better mobile support */}
                        <form onSubmit={handleBarcodeFormSubmit} className="flex gap-2">
                          <input
                            type="text"
                            value={currentInput}
                            onChange={(e: any) => handleInputChange(e)}
                            onKeyDown={(e: any) => handleKeyPress(e)}
                            onKeyPress={(e: any) => handleKeyPress(e)} // Add this for additional mobile support
                            maxLength={12}
                            placeholder="Scan a barcode and press Enter"
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
                          />

                          {/* Add visible button for mobile users */}
                          <button
                            type="button"
                            onClick={handleAddBarcode}
                            className="px-4 py-2 bg-[#E04343] text-white rounded-md hover:bg-red-600 transition-colors whitespace-nowrap"
                          >
                            Add
                          </button>
                        </form>

                        <p className="text-xs text-gray-500 mt-1">
                          Type or scan barcode, then press Enter or tap "Add"
                        </p>
                      </div>

                      {/* Enhanced Barcode List with Validation Status */}
                      <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                          Scanned Barcodes with Validation Status:
                        </label>
                        <div className="border border-gray-300 rounded-md p-2 max-h-60 overflow-y-auto">
                          {barcodeValues.length === 0 ? (
                            <div className="text-gray-500 text-center py-4">No barcodes scanned yet</div>
                          ) : (
                            <div className="space-y-1">
                              {barcodeValues.map((barcode, index) => (
                                <div
                                  key={index}
                                  className={`flex items-center justify-between p-2 rounded ${getValidationColor(barcode)}`}
                                >
                                  <span className="font-mono">{barcode}</span>
                                  <div className="flex items-center space-x-2">
                                    {validationResults[barcode] === 'valid' && (
                                      <span className="text-green-600 flex items-center gap-1">
                                        ✓ Valid
                                        {shipmentStates[barcode] && (
                                          <span className={`text-xs px-1 py-0.5 rounded ${selectedDestinationState && shipmentStates[barcode].toLowerCase() !== selectedDestinationState.toLowerCase()
                                            ? 'bg-orange-100 text-orange-700 font-semibold'
                                            : 'bg-gray-100 text-gray-600'
                                            }`}>
                                            {shipmentStates[barcode]}
                                          </span>
                                        )}
                                      </span>
                                    )}
                                    {validationResults[barcode] === 'invalid' && (
                                      <span className="text-red-600">✗ Invalid</span>
                                    )}
                                    {validationResults[barcode] === 'duplicate' && (
                                      <span className="text-yellow-600">⚠ Duplicate</span>
                                    )}
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const newValues = barcodeValues.filter((_, i) => i !== index);
                                        setBarcodeValues(newValues);
                                        validateShipmentNumbers(newValues);

                                        // Clean up geofence state for removed shipment
                                        const removedBarcode = barcodeValues[index];
                                        setShipmentStates(prev => {
                                          const updated = { ...prev };
                                          delete updated[removedBarcode];
                                          return updated;
                                        });
                                        setGeofenceMismatches(prev => prev.filter(num => num !== removedBarcode));
                                      }}
                                      className="text-red-500 hover:text-red-700"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Bulk Edit Textarea */}
                      <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                          Bulk Edit (One per line):
                        </label>
                        <textarea
                          value={barcodeValues.join("\n")}
                          onChange={handleBarcodeListChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#E04343]"
                          rows={5}
                          placeholder="Enter shipment numbers, one per line"
                        />
                      </div>

                      {/* Action Buttons */}
                      <div className="flex space-x-2 mb-4">
                        <button
                          type="button"
                          onClick={() => {
                            setBarcodeValues([]);
                            setValidationResults({});
                            setScannerStats({ total: 0, valid: 0, invalid: 0, duplicates: 0 });
                          }}
                          className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        >
                          Clear All
                        </button>
                        <button
                          type="button"
                          onClick={() => validateShipmentNumbers(barcodeValues)}
                          disabled={isValidating || barcodeValues.length === 0}
                          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
                        >
                          Re-validate
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            // Remove only invalid and duplicate shipments
                            const validOnly = barcodeValues.filter(barcode =>
                              validationResults[barcode] === 'valid'
                            );
                            setBarcodeValues(validOnly);
                            validateShipmentNumbers(validOnly);
                            toast.success(`Removed ${barcodeValues.length - validOnly.length} invalid/duplicate shipments`);
                          }}
                          disabled={scannerStats.invalid === 0 && scannerStats.duplicates === 0}
                          className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
                        >
                          Remove Invalid ({scannerStats.invalid + scannerStats.duplicates})
                        </button>
                      </div>

                      <p className="text-sm text-gray-500">
                        Scan barcodes or type them manually. Valid shipments will be highlighted in green,
                        invalid ones in red, and duplicates in yellow. Click the ✕ to remove individual items.
                      </p>
                    </div>
                    {/* Submit Button */}
                    <div className="flex justify-end pb-8 mt-6">
                      <div className="mt-1">
                        <button
                          disabled={loading}
                          type="submit"
                          className="text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px] disabled:opacity-50"
                        >
                          <div className="flex justify-center gap-3">
                            <span>
                              Create Manifest ({scannerStats.valid} valid shipments)
                              {geofenceMismatches.length > 0 && (
                                <span className="ml-1 text-yellow-300">⚠ {geofenceMismatches.length} state mismatch</span>
                              )}
                            </span>
                            <Oval
                              visible={loading}
                              height="20"
                              width="20"
                              color="#E04343"
                              secondaryColor="#FCBF94"
                              ariaLabel="oval-loading"
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </section>

      {/* Update Manifest Modal */}
      <section>
        <Modal
          visible={riderModal}
          width="900"
          height="600"
          effect="fadeInUp"
          onClickAway={() => !loading && !isUpdatingBatch && setRiderModal(false)}
        >
          {(loading || isUpdatingBatch) ? (
            <div className="flex flex-col items-center justify-center h-full p-8">
              {isUpdatingBatch ? (
                <>
                  {/* Progress Header */}
                  <h3 className="text-xl font-semibold text-gray-800 mb-6">
                    Updating Manifest Shipments
                  </h3>
                  {updateBatchInfo.apiCallsMade !== undefined && (
                    <div className="mt-4 bg-blue-50 p-3 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <span className="font-semibold">API Optimization:</span>
                        {' '}Processing up to 400 shipments per API call
                      </p>
                      <p className="text-xs text-blue-600 mt-1">
                        API calls made: {updateBatchInfo.apiCallsMade || 0}
                      </p>
                    </div>
                  )}


                  {/* Progress Bar */}
                  <div className="w-full max-w-md mb-6">
                    <div className="flex justify-between mb-2">
                      <span className="text-sm font-medium text-gray-700">
                        Processing Batch {updateBatchInfo.currentBatch} of {updateBatchInfo.totalBatches}
                      </span>
                      <span className="text-sm font-medium text-[#E04343]">
                        {updateProgress.toFixed(1)}%
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                      <div
                        className="bg-gradient-to-r from-[#E04343] to-[#ff6b6b] h-4 rounded-full transition-all duration-300 ease-out"
                        style={{ width: `${updateProgress}%` }}
                      />
                    </div>
                  </div>

                  {/* Statistics Cards */}
                  <div className="grid grid-cols-2 gap-4 w-full max-w-md mb-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center border border-blue-200">
                      <div className="text-2xl font-bold text-blue-600">
                        {updateBatchInfo.currentBatch}/{updateBatchInfo.totalBatches}
                      </div>
                      <div className="text-sm text-blue-800">Batch Progress</div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg text-center border border-green-200">
                      <div className="text-2xl font-bold text-green-600">
                        {updateBatchInfo.updatedCount}
                      </div>
                      <div className="text-sm text-green-800">Updated</div>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg text-center border border-purple-200">
                      <div className="text-2xl font-bold text-purple-600">
                        {updateBatchInfo.totalShipments}
                      </div>
                      <div className="text-sm text-purple-800">Total Shipments</div>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg text-center border border-red-200">
                      <div className="text-2xl font-bold text-red-600">
                        {updateBatchInfo.failedCount}
                      </div>
                      <div className="text-sm text-red-800">Failed</div>
                    </div>
                  </div>

                  {/* Loading Spinner */}
                  <Oval
                    visible={true}
                    height="60"
                    width="60"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />

                  {/* Status Message */}
                  <p className="mt-4 text-gray-600 text-center">
                    Updating shipments and syncing with third-party services...
                    <br />
                    <span className="text-sm text-gray-500 mt-2 block">
                      ⚠️ Please do not close this window until complete
                    </span>
                  </p>
                </>
              ) : (
                // Simple loading state for initial metadata update
                <div className="flex flex-col items-center">
                  <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#E04343"
                    secondaryColor="#FCBF94"
                    ariaLabel="oval-loading"
                  />
                  <p className="mt-4 text-gray-600">Updating manifest...</p>
                </div>
              )}
            </div>
          ) : (
            // Original form content
            <div style={{ height: '100%', overflow: 'auto' }}>
              <div className="container bg-[#fff] rounded-lg p-2">
                <div className="px-3">
                  <span className="flex justify-between px-2 pt-3">
                    <p className='mt-2 text-lg font-semibold'>Update Manifest</p>
                    <p className="cursor-pointer font-bold" onClick={(e) => setRiderModal(false)}>
                      <SvgElement type={icontypesEnum.CANCEL} />
                    </p>
                  </span>

                  <form onSubmit={updateManifest}>
                    <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto mt-5">
                      <div className="relative flex flex-col min-w-0 break-words w-full">
                        <div className="flex-auto py-5 pt-0">
                          <div className="flex flex-wrap">
                            <div className="lg:w-4/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Manifest Name</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  name='manifest_name'
                                  defaultValue={fleetData2?.manifest_name}
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                />
                              </div>
                            </div>

                            <div className="lg:w-8/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block text-sm font-semibold text-[#19213D]">Goods Description</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <textarea
                                  name='goods_description'
                                  defaultValue={fleetData2?.goods_description}
                                  onChange={() => handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                />
                              </div>
                            </div>

                            <div className="w-full lg:w-3/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Destination State
                                </label>
                                <select
                                  name='destination_state'
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] bg-white text-[#333333] text-sm rounded-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value={fleetData2?.destination_state}>{fleetData2?.destination_state}</option>
                                  {stateFrom?.data?.filter((data: any) => data?.client_id == null)?.map((state: any, index: any) => (
                                    <option key={index} value={state?.state_name}>{state?.state_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full lg:w-3/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Status
                                </label>
                                <select
                                  name='shipment_status'
                                  onChange={handleChange2}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value={fleetData2?.shipment_status}>{fleetData2?.shipment_status}</option>
                                  <option value={'Console Arrived at Facility (Blind Scan)'}>{'Console Arrived at Facility (Blind Scan)'}</option>
                                  <option value={'Arrived Hub'}>{'Arrived Hub'}</option>
                                  <option value={'Out for Delivery'}>{'Out for Delivery'}</option>
                                  {STATUSTYPES?.filter((status: any) => status?.EventName !== 'Proof of Delivery')?.map((status: any, index: any) => (
                                    <option key={index} value={status?.EventName}>{status?.EventName}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full lg:w-3/12 lg:pr-4">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Fleet
                                </label>
                                <select
                                  onChange={(e: any) => { handleChange2(e); getAllVehicles(e?.target?.value) }}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value={fleetData2?.fleet_name}>{fleetData2?.fleet_name}</option>
                                  {fleetData?.map((fleet: any, index: any) => (
                                    <option key={index} value={fleet?.id}>{fleet?.first_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="w-full lg:w-3/12">
                              <div className="relative w-full mb-5">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Select Vehicle
                                </label>
                                <select
                                  name='vehicle_name'
                                  onChange={handleChange2}
                                  className="bg-white border-[0.5px] border-[#DADADA] text-[#333333] text-sm rounded-r-[5px] block w-full p-2 placeholder:text-[#DADADA] placeholder:text-[12px] ease-linear transition-all duration-150"
                                >
                                  <option value={fleetData2?.vehicle_name}>{fleetData2?.vehicle_name}</option>
                                  {vehicle?.filter((veh: any) => veh?.status === 'Available')?.map((veh: any, index: any) => (
                                    <option key={index} value={veh?.vehicle_name}>{veh?.vehicle_name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Fleet Price</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="number"
                                  name='fleet_price'
                                  defaultValue={fleetData2?.fleet_price}
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                />
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">No. of Items</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="number"
                                  name='pcs'
                                  defaultValue={fleetData2?.pcs}
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                />
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Weight (KG)</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  name='weight'
                                  defaultValue={fleetData2?.weight}
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="0.0"
                                />
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">Custom Value</label>
                                <SvgElement type={icontypesEnum.QUESTIONMARK} />
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="text"
                                  name='custom_value'
                                  defaultValue={fleetData2?.custom_value}
                                  onChange={handleChange2}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2.5"
                                  placeholder="Enter custom value"
                                />
                              </div>
                            </div>

                            <div className="lg:w-3/12 w-full lg:pr-4">
                              <div className="flex justify-between mb-3">
                                <label className="block mb-2 text-sm font-semibold text-[#19213D]">
                                  Event Date/Time
                                </label>
                              </div>
                              <div className="relative mb-4">
                                <input
                                  type="datetime-local"
                                  value={statusUpdateDateTime}
                                  max={(() => {
                                    const now = new Date();
                                    const offset = now.getTimezoneOffset();
                                    return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                                  })()}
                                  onChange={(e) => {
                                    const now = new Date();
                                    const offset = now.getTimezoneOffset();
                                    const localNow = new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 16);
                                    if (e.target.value <= localNow) {
                                      setStatusUpdateDateTime(e.target.value);
                                    }
                                  }}
                                  className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full p-2.5"
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                  Only current or past date/time allowed.
                                </p>
                              </div>
                            </div>



                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Info Banner about batch processing */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4 mx-3">
                      <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <span className="text-sm text-blue-800">
                          <strong>Note:</strong> If you change the status, all shipments in this manifest will be updated in batches to ensure reliable processing.
                        </span>
                      </div>
                    </div>

                    <div className="flex justify-end pb-8 px-3">
                      <div className="mt-1">
                        <button
                          type="submit"
                          disabled={loading || isUpdatingBatch}
                          className="text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px] disabled:opacity-50"
                        >
                          <div className="flex justify-center gap-3">
                            <span>Update Manifest</span>
                            <Oval
                              visible={loading}
                              height="20"
                              width="20"
                              color="#E04343"
                              secondaryColor="#FCBF94"
                              ariaLabel="oval-loading"
                            />
                          </div>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </section>


      {/* Quick Create/Edit Airwaybill Number Modal */}
      <section>
        <Modal
          visible={showAirwaybillCreateModal}
          width="500"
          height="450"
          effect="fadeInUp"
          onClickAway={() => {
            if (!airwaybillLoading) {
              cancelEditingAirwaybill();
            }
          }}
        >
          <div className="bg-white rounded-lg p-6 h-full overflow-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-semibold text-gray-900">
                {editingAirwaybill ? 'Edit Airwaybill Number' : 'Create New Airwaybill Number'}
              </h3>
              <button
                onClick={cancelEditingAirwaybill}
                disabled={airwaybillLoading}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={editingAirwaybill ? handleUpdateAirwaybillNumber : handleCreateAirwaybillNumber}>
              {/* Airwaybill Number Input */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Airwaybill Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  value={airwaybillFormData.airwaybill_number}
                  onChange={(e) => setAirwaybillFormData({
                    ...airwaybillFormData,
                    airwaybill_number: e.target.value
                  })}
                  className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343]"
                  placeholder="e.g., AWB-2024-001"
                  disabled={airwaybillLoading}
                />
                <p className="text-xs text-gray-500 mt-1">
                  Enter a unique airwaybill number identifier
                </p>
              </div>

              {/* Description Input */}
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Description (Optional)
                </label>
                <textarea
                  rows={3}
                  value={airwaybillFormData.description}
                  onChange={(e) => setAirwaybillFormData({
                    ...airwaybillFormData,
                    description: e.target.value
                  })}
                  className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343]"
                  placeholder="Add notes or description for this airwaybill number..."
                  disabled={airwaybillLoading}
                />
              </div>

              {/* Status Select */}
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Status
                </label>
                <select
                  value={airwaybillFormData.status}
                  onChange={(e) => setAirwaybillFormData({
                    ...airwaybillFormData,
                    status: e.target.value
                  })}
                  className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343]"
                  disabled={airwaybillLoading}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  type="submit"
                  disabled={airwaybillLoading}
                  className="flex-1 bg-[#E04343] text-white py-2.5 px-4 rounded-lg font-medium hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {airwaybillLoading ? (
                    <>
                      <Oval height="20" width="20" color="#ffffff" secondaryColor="#ffffff" />
                      <span>{editingAirwaybill ? 'Updating...' : 'Creating...'}</span>
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{editingAirwaybill ? 'Update' : 'Create'} Airwaybill Number</span>
                    </>
                  )}
                </button>

                <button
                  type="button"
                  onClick={cancelEditingAirwaybill}
                  disabled={airwaybillLoading}
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </section>

      {/* Management Side Drawer */}
      <section>
        <Modal
          visible={showAirwaybillDrawer}
          width="600"
          height="100%"
          effect="fadeInRight"
          onClickAway={() => {
            if (!airwaybillLoading) {
              setShowAirwaybillDrawer(false);
              setAirwaybillSearchTerm('');
            }
          }}
        >
          <div className="bg-white h-full flex flex-col">
            {/* Header */}
            <div className="border-b border-gray-200 p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold text-gray-900">
                  Manage Airwaybill Numbers
                </h2>
                <button
                  onClick={() => setShowAirwaybillDrawer(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Search Bar */}
              <div className="relative">
                <input
                  type="text"
                  value={airwaybillSearchTerm}
                  onChange={(e) => setAirwaybillSearchTerm(e.target.value)}
                  placeholder="Search airwaybill numbers..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#E04343] focus:border-[#E04343]"
                />
                <svg className="w-5 h-5 text-gray-400 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>

              {/* Create New Button */}
              <button
                onClick={() => {
                  setShowAirwaybillDrawer(false);
                  setShowAirwaybillCreateModal(true);
                }}
                className="w-full mt-4 bg-[#E04343] text-white py-2.5 px-4 rounded-lg font-medium hover:bg-red-600 transition-colors flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Create New Airwaybill Number
              </button>
            </div>

            {/* List */}
            <div className="flex-1 overflow-y-auto p-6">
              {airwaybillLoading ? (
                <div className="flex justify-center items-center h-64">
                  <Oval height="60" width="60" color="#E04343" secondaryColor="#FCBF94" />
                </div>
              ) : airwaybillNumbers.length === 0 ? (
                <div className="text-center py-12">
                  <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="text-gray-500 text-lg">No airwaybill numbers found</p>
                  <p className="text-gray-400 text-sm mt-2">Create your first airwaybill number to get started</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {airwaybillNumbers
                    .filter((aw: any) =>
                      aw.airwaybill_number.toLowerCase().includes(airwaybillSearchTerm.toLowerCase()) ||
                      (aw.description && aw.description.toLowerCase().includes(airwaybillSearchTerm.toLowerCase()))
                    )
                    .map((aw: any) => (
                      <div
                        key={aw.id}
                        className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow bg-white"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-1">
                              <h3 className="font-semibold text-gray-900 text-lg">
                                {aw.airwaybill_number}
                              </h3>
                              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${aw.status === 'active'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-gray-100 text-gray-800'
                                }`}>
                                {aw.status === 'active' ? '✓ Active' : '○ Inactive'}
                              </span>
                            </div>
                            {aw.description && (
                              <p className="text-sm text-gray-600 mb-2">
                                {aw.description}
                              </p>
                            )}
                            <div className="flex items-center gap-4 text-xs text-gray-500">
                              <span className="flex items-center gap-1">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                {aw.manifests_count || 0} manifests
                              </span>
                              <span>
                                Created {new Date(aw.created_at).toLocaleDateString()}
                              </span>
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div className="flex gap-2 ml-4">
                            <button
                              onClick={() => {
                                setShowAirwaybillDrawer(false);
                                startEditingAirwaybill(aw);
                              }}
                              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                              title="Edit"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                            <button
                              onClick={() => handleDeleteAirwaybillNumber(aw.id)}
                              disabled={airwaybillLoading}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
                              title="Delete"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="border-t border-gray-200 p-6">
              <button
                onClick={() => setShowAirwaybillDrawer(false)}
                className="w-full py-2.5 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </section>


      {/* Status Update Modal */}
      <section>
        <Modal
          visible={statusModal}
          width="350"
          height="750"
          effect="fadeInUp"
          onClickAway={() => setStatusModal(false)}
        >
          <StatusUpdateModalContent
            shipmentId={shipmentId}
            userLoginData={userLoginData}
            statusOptions={statusOptions}
            canBypassCode={canBypassCode}
            onClose={() => {
              setStatusModal(false);
              setShipmentId([]);
            }}
            onSubmit={(data: any) => {
              // Your existing updateShipment logic here
              let eventCode = '';
              data.setLoading(true);

              STATUSTYPES?.filter((item: any) => item?.EventName == data.shipmentStatus)?.map((datas: any) => {
                eventCode = datas?.EventCode;
              });

              let shiData = shipmentId;
              let shipment = [
                {
                  "ThirdPartyToken": "null",
                  "SenderDetails": {
                    "SenderName": shiData?.SenderName || 'null',
                    "SenderCompanyName": shiData?.SenderCompanyName || "null",
                    "SenderCountryCode": shiData?.SenderCountryCode || "null",
                    "SenderAdd1": shiData?.SenderAdd1 || "null",
                    "SenderAdd2": shiData?.SenderAdd2 || 'null',
                    "SenderAdd3": shiData?.SenderAdd3 || 'null',
                    "SenderAddCity": shiData?.SenderAddCity || 'null',
                    "SenderAddState": shiData?.SenderAddState || 'null',
                    "SenderAddPostcode": shiData?.SenderAddPostcode || 'null',
                    "SenderPhone": shiData?.SenderPhone || 'null',
                    "SenderEmail": shiData?.SenderEmail || 'null',
                    "SenderFax": shiData?.SenderFax || 'null',
                    "SenderKycType": shiData?.SenderKycType || 'null',
                    "SenderKycNumber": shiData?.SenderKycNumber || 'null',
                    "SenderReceivingCountryTaxID": shiData?.SenderReceivingCountryTaxID || 'null'
                  },
                  "ReceiverDetails": {
                    "ReceiverName": shiData?.ReceiverName || 'null',
                    "ReceiverCompanyName": shiData?.ReceiverCompanyName || 'null',
                    "ReceiverCountryCode": shiData?.ReceiverCountryCode || 'null',
                    "ReceiverAdd1": shiData?.ReceiverAdd1 || 'null',
                    "ReceiverAdd2": shiData?.ReceiverAdd2 || 'null',
                    "ReceiverAdd3": shiData?.ReceiverAdd3 || 'null',
                    "ReceiverAddCity": shiData?.ReceiverAddCity || 'null',
                    "ReceiverAddState": shiData?.ReceiverAddState || 'null',
                    "ReceiverAddPostcode": shiData?.ReceiverAddPostcode || 'null',
                    "ReceiverMobile": shiData?.ReceiverMobile || 'null',
                    "ReceiverPhone": shiData?.ReceiverPhone || 'null',
                    "ReceiverEmail": shiData?.ReceiverEmail || 'null',
                    "ReceiverAddResidential": shiData?.ReceiverAddResidential || 'null',
                    "ReceiverFax": shiData?.ReceiverFax || 'null',
                    "ReceiverKycType": shiData?.ReceiverKycType || 'null',
                    "ReceiverKycNumber": shiData?.ReceiverKycNumber || 'null'
                  },
                  "PackageDetails": {
                    "GoodsDescription": shiData?.GoodsDescription || 'null',
                    "CustomValue": shiData?.CustomValue || 0,
                    "CustomCurrencyCode": shiData?.CustomCurrencyCode || 'null',
                    "InsuranceValue": shiData?.InsuranceValue || 0,
                    "InsuranceCurrencyCode": shiData?.InsuranceCurrencyCode || 'null',
                    "ShipmentTerm": shiData?.ShipmentTerm || 'null',
                    "GoodsOriginCountryCode": shiData?.GoodsOriginCountryCode || 'null',
                    "DeliveryInstructions": data.delieveryInstruction || 'null',
                    "Weight": shiData?.Weight || 0,
                    "WeightMeasurement": shiData?.WeightMeasurement || 'null',
                    "NoOfItems": shiData?.NoOfItems || 0,
                    "CubicL": shiData?.CubicL || 0,
                    "CubicW": shiData?.CubicW || 0,
                    "CubicH": shiData?.CubicH || 0,
                    "CubicWeight": shiData?.CubicWeight || 0,
                    "ServiceTypeName": shiData?.ServiceTypeName || 'null',
                    "BookPickUP": false,
                    "AlternateRef": shiData?.AlternateRef || 'null',
                    "SenderRef1": shiData?.SenderRef1 || 'null',
                    "SenderRef2": shiData?.SenderRef2 || 'null',
                    "SenderRef3": shiData?.SenderRef3 || 'null',
                    "DeliveryAgentCode": shiData?.DeliveryAgentCode || 'null',
                    "DeliveryRouteCode": shiData?.DeliveryRouteCode || 'null',
                    "BusinessType": shiData?.BusinessType || 'B2B',
                    "ShipmentResponseItem": [{
                      "ItemAlt": "null",
                      "ItemNoOfPcs": shiData?.NoOfItems || 'null',
                      "ItemCubicL": shiData?.CubicL || 'null',
                      "ItemCubicW": shiData?.CubicW || 'null',
                      "ItemCubicH": shiData?.CubicH || 'null',
                      "ItemWeight": shiData?.Weight || 'null',
                      "ItemCubicWeight": shiData?.CubicWeight || 'null',
                      "ItemDescription": shiData?.GoodsDescription || 'null',
                      "ItemCustomValue": shiData?.CustomValue || 'null',
                      "ItemCustomCurrencyCode": shiData?.CustomCurrencyCode || 'null',
                      "Notes": shiData?.Notes || 'null'
                    }],
                    "CODAmount": shiData?.CODAmount || 0,
                    "CODCurrencyCode": shiData?.CODCurrencyCode || 'null',
                    "Bag": shiData?.Bag || 0,
                    "Notes": shiData?.Notes || 'null',
                    "OriginLocCode": shiData?.OriginLocCode || 'null',
                    "BagNumber": shiData?.BagNumber || 'null',
                    "DeadWeight": shiData?.DeadWeight || 0,
                    "ReasonExport": shiData?.ReasonExport || 'null',
                    "DestTaxes": shiData?.DestTaxes || 0,
                    "Security": shiData?.Security || 0,
                    "Surcharge": shiData?.Surcharge || 0,
                    "ReceiverTaxID": shiData?.ReceiverTaxID || 'null',
                    "OrderNumber": shiData?.OrderNumber || 0,
                    "Incoterms": shiData?.Incoterms || 'null',
                    "ClearanceReference": shiData?.ClearanceReference || 'null'
                  }
                }
              ];

              const formData = new FormData();
              formData.append('Status', data.shipmentStatus || shipmentId?.status);
              formData.append('status_id', eventCode);
              formData.append('id', shipmentId?.id);
              formData.append('del_instruction', data.delieveryInstruction);
              formData.append('shiData', JSON.stringify(shipment));
              formData.append('delievery_code', canBypassCode ? 'bypass' : data.delieveryCode);
              formData.append('del_doc', data.img1);
              formData.append('updated_at', data.eventDateTime);


              SuperAdminApis.updateShipmentStatusForDelivery(formData)
                .then((response: any) => {
                  if (response?.data?.status) {
                    toast.success(response?.data?.message);
                    setStatusModal(false);
                    data.setLoading(false);

                    const query: any = { search: '' };
                    SuperAdminApis.getSingleManifest(nextPageId).then(
                      (response: AxiosResponse<any>) => {
                        if (response?.data) {
                          setManifestData(response?.data?.data);
                        }
                      }
                    );
                  } else {
                    toast.warn(response?.data?.message);
                    setStatusModal(false);
                    data.setLoading(false);
                  }
                })
                .catch((err: any) => {
                  console.log(err);
                  setStatusModal(false);
                  // 🔄 Handle transition blocked errors
                  if (err?.response?.data?.error === 'INVALID_STATUS_TRANSITION') {
                    const workflowInfo = err.response.data.workflow_info;
                    const allowedNames = workflowInfo?.allowed_next?.map((s: any) => s.name).join(', ');

                    toast.error(
                      `${err.response.data.message}${allowedNames ? ` Allowed: ${allowedNames}` : ''}`
                    );
                  } else {
                    toast.error(err?.response?.data?.message || 'Failed to update shipment status.');
                  }

                  data.setLoading(false);
                });
            }}
          />
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={12000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default Manifest;